import * as ReactDOMServer from 'react-dom/server';

import Button from "react-bootstrap/Button";
import MarkerIconSvg from "./marker-icon.svg";
import MdLocalGroceryStore from "./MdLocalGroceryStore.svg";
import FruitsPear from "./fruits-pear-svgrepo-com.svg";
import * as GeoJSON from 'geojson';
// Removed duplicate: import type { AnySource } from 'react-map-gl';
import GroceryStoreMarketStoreFreshProduce
    from "./grocery-store-market-store-fresh-produce-svgrepo-com.svg";
import SuppliesBasketGroceriesShoppintBasketFull
    from "./supplies-basket-groceries-shopping-basket-full-svgrepo-com.svg";
import VegetablesSalad from "./vegetables-salad-2-svgrepo-com.svg";
import Tomato from "./tomato-svgrepo-com.svg";
import Warehouse from "./warehouse-svgrepo-com.svg";
import FaBasketShopping from "./FaBasketShopping.svg";
import GiFruitBowl from "./GiFruitBowl.svg";
import IoStorefrontSharp from "./IoStorefrontSharp.svg";
// import StarIconSvg from "./star-icon.svg";
import {useMap} from 'react-map-gl';
import Modal from 'react-bootstrap/Modal';
import * as turf from '@turf/turf';
import * as React from 'react';
import {useRef, useState, useCallback} from 'react';
import type {MapRef} from 'react-map-gl';
import type {FillLayer, LineLayer, CircleLayer, SymbolLayer, RasterLayer, AnySource} // Changed from AnySourceData
    from 'react-map-gl';
import {
    Map,
    Source,
    Layer,
    Marker,
    Popup,
    NavigationControl,
} from 'react-map-gl';
import WelcomeMessage from "../components/WelcomeMessage";
import LayerControl from "../components/LayerControl";
import GeocoderControl from "../components/GeocoderControl";
import ColorKeyControl from "../components/ColorKeyControl";
import SitingModeControl from "../components/SitingModeControl";
import FacilityFilterControl from "../components/FacilityFilterControl";
import BaselineResultsControl from "../components/BaselineResultsControl";
import PathwaysResultsControl from "../components/PathwaysResultsControl";
import incomeData from "../../../../map/filedata/prod/county_income_2022.json"
import precipData from "../../../../map/filedata/prod/precip_noaa_prod.json"
import outagesData from "../../../../map/filedata/prod/outages_prod.json"
import tempData from "../../../../map/filedata/prod/temp_noaa_prod.json"
import heatDegDaysData from "../../../../map/filedata/prod/hdd_noaa_prod.json"
import coolDegDaysData from "../../../../map/filedata/prod/cdd_noaa_prod.json"
import foodAccessData from "../../../../map/filedata/prod/food_access.json"
import edPopLessThanHsData from
        "../../../../map/filedata/prod/ed_pop_less_than_hs.json"
import edPopHsOrHigherData from
        "../../../../map/filedata/prod/ed_pop_hs_or_higher.json"
import edPopBachelorsOrHigherData from
        "../../../../map/filedata/prod/ed_pop_bachelors_or_higher.json"
import unemployData
    from "../../../../map/filedata/prod/county_unemployment_rate.json"
import popDensityData
    from "../../../../map/filedata/prod/county_pop_per_sq_km_2023.json"
import airQualData
    from "../../../../map/filedata/prod/county_air_qual_nonattainment.json"
import elecPriceData from
        "../../../../map/filedata/prod/elec_price_nrel_prod.json"
import natGasPriceData from
        "../../../../map/filedata/prod/natural_gas_rates.json"
import {all} from "axios";
import {
    numWithCommas,
    numWithCommasUSD,
    hasLetters,
    findNearestFacility,
    stateFpToName
} from
        "../utils/utils";
import LandfillPopup from "../components/popups/LandfillPopup";
import GenericCircleLayerPopup
    from "../components/popups/GenericCircleLayerPopup";
import GenericFillLayerPopup
    from "../components/popups/GenericFillLayerPopup";
import FillLayerStackPopup from "../components/popups/FillLayerStackPopup";
import GenericLineLayerPopup from "../components/popups/GenericLineLayerPopup";

// import MoonLoader from "react-spinners/MoonLoader";
import RingLoader from "react-spinners/RingLoader";
import ScaleLoader from "react-spinners/ScaleLoader";
import {CSSProperties} from "react";

const override: CSSProperties = {
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    // borderColor: "blue",
    position: "relative",
    top: "80px",
};


const circRad = 3
const circStrokeWidth = 0.3
const HIDE_UNAVAILABLE_DATA_IN_POPUPS = true
const DEFAULT_SEARCH_RAD_FILL_OPACITY = 0.2
const mapboxAccessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN

const iconSizeStops = [
    [1, 0.2],
    [7, 0.3],
    [8, 0.3],
    [9, 0.4],
    [10, 0.5],
    [11, 0.6],
    [12, 0.7],
    [13, 0.8],
    [14, 0.9],
    [15, 1],
];

const circRadStops = [
    [1, 0],
    [2, 0],
    [3, 0],
    [6, 3],
    [7, 3.5],
    [8, 4],
    [9, 4.5],
    [10, 5],
    [11, 5.9],
    [12, 6.1],
    [13, 6.3],
    [14, 6.5],
    [15, 7]
];
const layerTree = [
    {
        id: 1,
        title: "Climate & Environment",
        hasCheckbox: false,
        children: [
            { id: "climateZones", title: "Climate Zone", hasCheckbox: true },
            { id: "precip", title: "Precipitation", hasCheckbox: true },
            { id: "temperature", title: "Temperature", hasCheckbox: true },
            { id: "heatDegDays", title: "Heating Degree Days", hasCheckbox: true },
            { id: "coolDegDays", title: "Cooling Degree Days", hasCheckbox: true },
            { id: "solarInsolation", title: "Solar Insolation", hasCheckbox: true },
            { id: "windPowerClass", title: "Wind Power Class", hasCheckbox: true },
            { id: "geothermWellsSprings", title: "Geothermal Wells & Springs", hasCheckbox: true },
            { id: "geothermTemp", title: "Geothermal Temperature", hasCheckbox: true },
            { id: "airQual", title: "Air Quality Non-Attainment Zones", hasCheckbox: true },
            { id: "soilProp", title: "Soil Properties", hasCheckbox: true },
            { id: "soilSlope", title: "Soil Slope", hasCheckbox: true }, // RESTORED
        ]
    },
    {
        id: 2,
        title: "Land Use & Utilities",
        hasCheckbox: false,
        children: [
            { id: "landCover", title: "Land Cover", hasCheckbox: true },
            { id: "landUse", title: "Land Use", hasCheckbox: true },
            { id: "landValue", title: "Land Value", hasCheckbox: true },
            { id: "zoning", title: "Land Zoning", hasCheckbox: true },
            { id: "crops", title: "Cropland", hasCheckbox: true },
            { id: "agLand", title: "Agricultural Land", hasCheckbox: true },
            { id: "freightNetwork", title: "Freight Network", hasCheckbox: true },
            {
                id: "utilities",
                title: "Utilities",
                hasCheckbox: false,
                children: [
                    { id: "wtrSrvcAreas", title: "Community Water System Service Areas", hasCheckbox: true },
                    { id: "wtrLines", title: "Water Lines", hasCheckbox: true },
                    { id: "wtrRates", title: "Water Rates", hasCheckbox: true },
                    { id: "wastewaterSrvcAreas", title: "Wastewater Service Areas", hasCheckbox: true },
                    { id: "wastewaterLines", title: "Wastewater Lines", hasCheckbox: true },
                    { id: "wastewaterTreatPlants", title: "Wastewater Treatment Plants", hasCheckbox: true },
                    { id: "onsiteSewageDisposal", title: "On-site Sewage Disposal Systems", hasCheckbox: true },
                    { id: "natGasLines", title: "Major Natural Gas Pipelines", hasCheckbox: true },
                    { id: "natGasPrice", title: "Natural Gas Rates", hasCheckbox: true },
                    { id: "elecPwrTransLines", title: "Power Transmission Lines", hasCheckbox: true },
                    { id: "elecPrice", title: "Electricity Rates", hasCheckbox: true },
                    { id: "substations", title: "Electric Substations", hasCheckbox: true },
                    { id: "outages", title: "Power Reliability", hasCheckbox: true },
                ]
            }
        ]
    },
    {
        id: 3,
        title: "Social & Economic",
        hasCheckbox: false,
        children: [
            {},
            { id: "popDensity", title: "Population Density", hasCheckbox: true },
            { id: "income", title: "Per Capita Income", hasCheckbox: true },
            { id: "ceaWorkers", title: "CEA Workers", hasCheckbox: true },
            { id: "ceaWages", title: "CEA Prevailing Wage", hasCheckbox: true },
            { id: "warehouseWorkers", title: "Warehouse Workers", hasCheckbox: true },
            { id: "unemploy", title: "Unemployment Rate", hasCheckbox: true },
            { id: "education", title: "Education Level", hasCheckbox: true },
            // { id: "disadvCommunities", title: "Disadvantaged Communities", hasCheckbox: true },
            { id: "opportunityZones", title: "Opportunity Zones", hasCheckbox: true },
            { id: "foodAccess", title: "Food Access", hasCheckbox: true },
        ]
    },
    {
        id: 4,
        title: "Co-Location Opportunities",
        hasCheckbox: false,
        children: [
            { id: "ceaFacilities", title: "CEA Facilities", hasCheckbox: true, layerType: 'circle' },
            { id: "compostFacilities", title: "Composting Facilities", hasCheckbox: true, layerType: 'circle' },
            { id: "foodBanks", title: "Food Banks", hasCheckbox: true, layerType: 'circle' },
            { id: "foodManufactProcessors", title: "Food Manufacturers & Processors", hasCheckbox: true, layerType: 'circle' },
            { id: "refrigFacilities", title: "Refrigerated Storage", hasCheckbox: true, layerType: 'circle' },
            { id: "farmersMarkets", title: "Farmers Markets", hasCheckbox: true, layerType: 'circle' },
            { id: 'collegesUnis', title: 'Colleges & Universities', hasCheckbox: true, layerType: 'circle' },
            { id: 'pwrPlants', title: 'Power Plants', hasCheckbox: true, layerType: 'circle' },
            { id: "microgrids", title: "Microgrids", hasCheckbox: true },
            { id: "chpPlants", title: "CHP Facilities", hasCheckbox: true },
            {
                id: "foodRetailers",
                title: "Food Wholesalers & Retailers",
                hasCheckbox: false,
                children: [
                    { id: "supermarkets", title: "Supermarkets & Grocery Stores", hasCheckbox: true },
                    { id: "fruitVegMarkets", title: "Fruit & Vegetable Markets", hasCheckbox: true },
                    { id: "fruitVegWholesalers", title: "Fruit & Vegetable Wholesalers", hasCheckbox: true },
                    { id: "warehouseClubs", title: "Warehouse Clubs & Supercenters", hasCheckbox: true },
                    { id: "generalWarehousingStorage", title: "General Warehousing & Storage", hasCheckbox: true },
                ]
            },
            {
                id: "biogasFacilities",
                title: "Biogas Facilities",
                hasCheckbox: false,
                children: [
                    { id: "anaerobDigesters", title: "Anaerobic Digesters", hasCheckbox: true, layerType: 'circle' },
                    { id: 'landfills', title: 'Landfills', hasCheckbox: true, layerType: 'circle' },
                ]
            }
        ]
    },
];

// Climate and environment layers
const climateZonesLayer: FillLayer = {
    id: 'climateZones',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.4qbkr8ys',
    'source-layer': 'US_climate_zones-38zwbf',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0.3,
        "fill-color": [
            "interpolate",
            ["linear"],
            ["get", "OBJECTID"],
            // gradient generator: https://colordesigner.io/gradient-generator
            1, '#ff1111',
            2, '#ff440b',
            3, '#ff7905',
            4, '#fdb100',
            5, '#f7e600',
            6, '#caf100',
            7, '#8eeb00',
            8, '#56e501',
            9, '#20de01',
            10, '#01d815',
            11, '#01d245',
            12, '#01cc72',
            13, '#01c69c',
            14, '#01bbc0',
            15, '#018ab9',
            16, '#015cb3',
            17, '#0131ad',
            18, '#0109a7'
        ]
    }
};

const precipExpr =
    [
        'get',
        ['string', ['get', 'GEOID']],
        ['literal', precipData]
    ]

const precipLayer: FillLayer = {
    id: 'precip',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.641ibxh3',
    'source-layer': 'us_counties_2021-1m8iiy',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    paint: {
        "fill-outline-color": "rgba(255, 255, 255, 1)",
        'fill-opacity': 0,
        'fill-color': [
            "interpolate",
            ["linear"],
            precipExpr,
            3, '#c74803',
            35, '#1cda1f',
            60, '#1c4eda',
        ],
    }
};

const tempExpr =
    [
        'get',
        ['string', ['get', 'GEOID']],
        ['literal', tempData]
    ]

const temperatureLayer: FillLayer = {
    id: 'temperature',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.641ibxh3',
    'source-layer': 'us_counties_2021-1m8iiy',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    paint: {
        "fill-outline-color": "rgba(255, 255, 255, 1)",
        'fill-opacity': 0,
        // Color gradient maker:
        // https://coolors.co/gradient-maker/0109a7-1cda1f-ff1111?position=0,49,100&opacity=100,100,100&type=linear&rotation=90
        'fill-color': [
            "interpolate",
            ["linear"],
            tempExpr,
            40, '#0109a7',
            50, '#1cda1f',
            70, '#ff1111',
        ],
    }
};

const heatDegDaysExpr =
    [
        'get',
        ['string', ['get', 'GEOID']],
        ['literal', heatDegDaysData]
    ]

const heatDegDaysLayer: FillLayer = {
    id: 'heatDegDays',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.641ibxh3',
    'source-layer': 'us_counties_2021-1m8iiy',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    paint: {
        "fill-outline-color": "rgba(255, 255, 255, 1)",
        'fill-opacity': 0,
        // Color gradient maker:
        // https://coolors.co/gradient-maker/0109a7-1cda1f-ff1111?position=0,49,100&opacity=100,100,100&type=linear&rotation=90
        'fill-color': [
            "interpolate",
            ["linear"],
            heatDegDaysExpr,
            11, '#ff1111',
            5000, '#1cda1f',
            10862, '#0109a7',
        ],
    }
};

const coolDegDaysExpr =
    [
        'get',
        ['string', ['get', 'GEOID']],
        ['literal', coolDegDaysData]
    ]

const coolDegDaysLayer: FillLayer = {
    id: 'coolDegDays',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.641ibxh3',
    'source-layer': 'us_counties_2021-1m8iiy',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    paint: {
        "fill-outline-color": "rgba(255, 255, 255, 1)",
        'fill-opacity': 0,
        // Color gradient maker:
        // https://coolors.co/gradient-maker/0109a7-1cda1f-ff1111?position=0,49,100&opacity=100,100,100&type=linear&rotation=90
        'fill-color': [
            "interpolate",
            ["linear"],
            coolDegDaysExpr,
            0, '#0109a7',
            2450, '#1cda1f',
            4910, '#ff1111',
        ],
    }
};

const solarInsolationLayer: FillLayer = {
    id: 'solarInsolation',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.6163x1e7',
    'source-layer': 'solar_photovoltaic',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    paint: {
        "fill-outline-color": "rgba(255, 255, 255, 1)",
        'fill-opacity': 0.0,
        'fill-color': [
            "interpolate",
            ["linear"],
            ['get', 'ANNUAL AVG'],
            2000, '#0109a7',
            2200, '#0131ad',
            2400, '#015cb3',
            2600, '#018ab9',
            2800, '#01bbc0',
            3000, '#01c69c',
            3200, '#01cc72',
            3400, '#01d245',
            3600, '#01d815',
            3800, '#20de01',
            4000, '#56e501',
            4200, '#8eeb00',
            4400, '#caf100',
            4600, '#f7e600',
            4800, '#fdb100',
            5000, '#ff7905',
            5500, '#ff440b',
            5900, '#ff1111',
            8900, '#ff1111'
        ],
    }
};

const windPowerClassLayer: FillLayer = {
    id: 'windPowerClass',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.wind_power',
    'source-layer': 'wind_power',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    paint: {
        "fill-outline-color": "rgba(255, 255, 255, 1)",
        'fill-opacity': 0.0,
        'fill-color': [
            "interpolate",
            ["linear"],
            ['get', 'WIND CLASS'],
            2, '#0109a7',
            // 2200, '#0131ad',
            // 2400, '#015cb3',
            3, '#018ab9',
            // 3, '#01bbc0',
            // 3000, '#01c69c',
            // 3200, '#01cc72',
            // 3400, '#01d245',
            4, '#01d815',
            // 3800, '#20de01',
            // 4000, '#56e501',
            // 4200, '#8eeb00',
            // 4400, '#caf100',
            5, '#f7e600',
            // 4800, '#fdb100',
            6, '#ff7905',
            // 5500, '#ff440b',
            // 5900, '#ff1111',
            7, '#ff1111'
        ],
    }
};

const geothermWellsSpringsLayer: CircleLayer = {
    id: 'geothermWellsSprings',
    type: 'circle',
    source: 'mapbox://ceascreeningtooldev.3jihkinx',
    'source-layer': 'geothermal_wells_springs',
    'layout': {
        'visibility': 'visible'
    },
    paint: {
        // 'circle-radius': circRad,
        'circle-radius': {stops: circRadStops},
        'circle-color': '#ce5514',
        'circle-opacity': 0.9,
        'circle-stroke-color': '#ffffff',
        'circle-stroke-width': circStrokeWidth
    }
};

const geothermTempLayer: FillLayer = {
    id: 'geothermTemp',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.24fzrbxh',
    'source-layer': 'geothermal_temp',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    paint: {
        "fill-outline-color": "rgba(255, 255, 255, 1)",
        'fill-opacity': 0,
        // 'fill-color': '#ea0101'
        'fill-color':
            [
                "interpolate",
                ["linear"],
                ["get", "ESTIMATED "],
                25,
                "#1565ec",
                250,
                "#f30101"
            ]
    }
};

const geothermTempKauaiLayer: FillLayer = {
    id: 'geothermTempKauai',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.geothermal_temp_hi',
    'source-layer': 'geothermal_temp_hi',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    paint: {
        "fill-outline-color": "rgba(255, 255, 255, 1)",
        'fill-opacity': 0,
        // 'fill-color': '#ea0101'
        'fill-color':
            [
                "interpolate",
                ["linear"],
                ["get", "ESTIMATED "],
                25,
                "#1565ec",
                250,
                "#f30101"
            ]
    }
};

const geothermWellsSpringsKauaiHiLayer: CircleLayer = {
    id: 'geothermWellsSpringsKauaiHi',
    type: 'circle',
    source: 'mapbox://ceascreeningtooldev.thermal_springs_kauai_hi',
    'source-layer': 'thermal_springs_kauai_hi',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    paint: {
        'circle-radius': {stops: circRadStops},
        // 'circle-radius': 2,
        'circle-color': '#44bdf1',
        'circle-opacity': 0.9,
        'circle-stroke-color': '#ffffff',
        'circle-stroke-width': circStrokeWidth
    }
};

const airQualLayer: FillLayer = {
    id: 'airQual',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.air_quality',
    'source-layer': 'air_quality',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#ce7714',
    }
};

const soilPropKauaiCountyHiLayer: FillLayer = {
    id: 'soilPropKauaiCountyHi',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.soils_kauai_county_hi',
    'source-layer': 'soils_kauai_county_hi',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#ce7714',
    }
};

const soilPropUsLayer: FillLayer = {
    id: 'soilPropUs',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.83l2nkf6',
    'source-layer': 'us_soils',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#c278c7',
    }
};

const soilSlopeLayer: RasterLayer = {
    id: 'soilSlope',
    type: 'raster',
    source: 'mapbox://ceascreeningtooldev.soil_slope',
    'source-layer': 'soil_slope',
    'metadata': {
        uidField: 'objectid'
    },
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "raster-opacity": 0.8,
    }
};


// Land use and utilities layers
const landCoverLayer: RasterLayer = {
    id: 'landCover',
    type: 'raster',
    source: 'mapbox://ceascreeningtooldev.land_cover_hi',
    'source-layer': 'land_cover_hi',
    'metadata': {
        uidField: 'objectid'
    },
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "raster-opacity": 0.8,
    }
};

const landCover2Layer: RasterLayer = {
    id: 'landCover2',
    type: 'raster',
    source: 'mapbox://ceascreeningtooldev.clipped_land_cover',
    'source-layer': 'clipped_land_cover',
    'metadata': {
        uidField: 'objectid'
    },
    'layout': {
        'visibility': 'visible'
    },
    "paint": {
        "raster-opacity": 0.8,
    }
};

const cropsLayer: RasterLayer = {
    id: 'crops',
    type: 'raster',
    source: 'mapbox://ceascreeningtooldev.clipped_cropland',
    'source-layer': 'clipped_cropland',
    'metadata': {
        uidField: 'objectid'
    },
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "raster-opacity": 0.8,
    }
};


const landUseWayneCountyMiLayer: FillLayer = {
    id: 'landUseWayneCountyMi',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.land_use_wayne_county_mi',
    'source-layer': 'land_use_wayne_county_mi',
    'metadata': {
        uidField: 'objectid'
    },
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#e7051b',
    }
};

const landUseRiversideCountyCaLayer: FillLayer = {
    id: 'landUseRiversideCountyCa',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.land_use_riverside_county_ca',
    'source-layer': 'land_use_riverside_county_ca',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#ea60f5',
    }
};

const landUseKauaiCountyHiLayer: FillLayer = {
    id: 'landUseKauaiCountyHi',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.parcels_kauai_hi',
    'source-layer': 'parcels_kauai_hi',
    'metadata': {
        uidField: 'objectid'
    },
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0.2,
        "fill-color": '#e7051b',
    }
};

const landUseErieCountyOhLayer: FillLayer = {
    'id': 'landUseErieCountyOh',
    'type': 'fill',
    'source': 'mapbox://ceascreeningtooldev.parcels_erie_county_oh',
    'source-layer': 'parcels_erie_county_oh',
    'metadata': {
        uidField: 'OBJECTID_1'
    },
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0.2,
        "fill-color": '#e7051b',
    }
};

const landUseLorainCountyOhLayer: FillLayer = {
    'id': 'landUseLorainCountyOh',
    'type': 'fill',
    'source': 'mapbox://ceascreeningtooldev.parcels_lorain_county_oh',
    'source-layer': 'parcels_lorain_county_oh',
    'metadata': {
        uidField: 'OBJECTID_1'
    },
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0.2,
        "fill-color": '#e7051b',
    }
};

const landUseWayneCountyOhLayer: FillLayer = {
    'id': 'landUseWayneCountyOh',
    'type': 'fill',
    'source': 'mapbox://ceascreeningtooldev.parcels_wayne_county_oh',
    'source-layer': 'parcels_wayne_county_oh',
    'metadata': {
        uidField: 'PIN'
    },
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0.2,
        "fill-color": '#e7051b',
    }
};

const landUseOttawaCountyOhLayer: FillLayer = {
    'id': 'landUseOttawaCountyOh',
    'type': 'fill',
    'source': 'mapbox://ceascreeningtooldev.parcels_ottawa_county_oh',
    'source-layer': 'parcels_ottawa_county_oh',
    'metadata': {
        uidField: 'PARCELID'
    },
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0.2,
        "fill-color": '#e7051b',
    }
};

const landUseLucasCountyOhLayer: FillLayer = {
    'id': 'landUseLucasCountyOh',
    'type': 'fill',
    'source': 'mapbox://ceascreeningtooldev.parcels_lucas_oh',
    'source-layer': 'parcels_lucas_oh',
    'metadata': {
        uidField: 'PARID'
    },
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0.2,
        "fill-color": '#e7051b',
    }
};

const landUseYorkCountyPaLayer: FillLayer = {
    id: 'landUseYorkCountyPa',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.york_county_pa_parcels',
    'metadata': {
        uidField: 'OBJECTID'
    },
    'source-layer': 'york_county_pa_parcels',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0.2,
        "fill-color": '#e7051b',
    }
};

const landValueRiversideCountyCaLayer: FillLayer = {
    id: 'landValueRiversideCountyCa',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.5xhocvwg',
    'source-layer': 'parcels_riverside_ca_prod',
    'metadata': {
        uidField: 'GEO_CD'
    },
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0.8,

        "fill-color": '#e7051b',
    }
};

const landValueLorainCountyOhLayer: FillLayer = {
    'id': 'landValueLorainCountyOh',
    'type': 'fill',
    'source': 'mapbox://ceascreeningtooldev.parcels_lorain_county_oh',
    'source-layer': 'parcels_lorain_county_oh',
    'metadata': {
        uidField: 'OBJECTID_1'
    },
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0.2,
        "fill-color": '#e7051b',
    }
};

const landValueMonroeCountyMiLayer: FillLayer = {
    'id': 'landValueMonroeCountyMi',
    'type': 'fill',
    'source': 'mapbox://ceascreeningtooldev.parcels_monroe_county_mi',
    'source-layer': 'parcels_monroe_county_mi',
    'metadata': {
        uidField: 'OBJECTID'
    },
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0.2,
        "fill-color": '#e7051b',
    }
};

const landValueErieCountyOhLayer: FillLayer = {
    'id': 'landValueErieCountyOh',
    'type': 'fill',
    'source': 'mapbox://ceascreeningtooldev.parcels_erie_county_oh',
    'source-layer': 'parcels_erie_county_oh',
    'metadata': {
        uidField: 'OBJECTID_1'
    },
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0.2,
        "fill-color": '#e7051b',
    }
};

const landValueWayneCountyOhLayer: FillLayer = {
    'id': 'landValueWayneCountyOh',
    'type': 'fill',
    'source': 'mapbox://ceascreeningtooldev.parcels_wayne_county_oh',
    'source-layer': 'parcels_wayne_county_oh',
    'metadata': {
        uidField: 'PIN'
    },
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0.2,
        "fill-color": '#e7051b',
    }
};

const landValueOttawaCountyOhLayer: FillLayer = {
    'id': 'landValueOttawaCountyOh',
    'type': 'fill',
    'source': 'mapbox://ceascreeningtooldev.parcels_ottawa_county_oh',
    'source-layer': 'parcels_ottawa_county_oh',
    'metadata': {
        uidField: 'PARCELID'
    },
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0.2,
        "fill-color": '#e7051b',
    }
};

const landValueLucasCountyOhLayer: FillLayer = {
    'id': 'landValueLucasCountyOh',
    'type': 'fill',
    'source': 'mapbox://ceascreeningtooldev.parcels_lucas_oh',
    'source-layer': 'parcels_lucas_oh',
    'metadata': {
        uidField: 'PARID'
    },
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0.2,
        "fill-color": '#e7051b',
    }
};

const landValueYorkCountyPaLayer: FillLayer = {
    id: 'landValueYorkCountyPa',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.york_county_pa_parcels',
    'metadata': {
        uidField: 'OBJECTID'
    },
    'source-layer': 'york_county_pa_parcels',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0.2,
        "fill-color": '#e7051b',
    }
};

const zoningKauaiHiLayer: FillLayer = {
    id: 'zoningKauaiHi',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.zoning_kauai_hi',
    'source-layer': 'zoning_kauai_hi',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#ea60f5',
    }
};

const zoningFultonCountyOhLayer: FillLayer = {
    id: 'zoningFultonCountyOh',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.zoning_fulton_county_oh',
    'source-layer': 'zoning_fulton_county_oh',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#ea60f5',
    }
};

const zoningLorainCountyOhLayer: FillLayer = {
    id: 'zoningLorainCountyOh',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.zoning_lorain_county_oh',
    'source-layer': 'zoning_lorain_county_oh',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#ea60f5',
    }
};

const zoningRichmondCountyGaLayer: FillLayer = {
    id: 'zoningRichmondCountyGa',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.zoning_richmond_county_ga',
    'source-layer': 'zoning_richmond_county_ga',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#ea60f5',
    }
};

const zoningOttawaCountyOhLayer: FillLayer = {
    id: 'zoningOttawaCountyOh',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.zoning_ottawa_county_oh',
    'source-layer': 'zoning_ottawa_county_oh',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#ea60f5',
    }
};

const zoningRiversideCountyCaLayer: FillLayer = {
    id: 'zoningRiversideCountyCa',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.zoning_riverside_county_ca',
    'source-layer': 'zoning_riverside_county_ca',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#ea60f5',
    }
};

const zoningRiversideCityCaLayer: FillLayer = {
    id: 'zoningRiversideCityCa',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.zoning_riverside_city_ca',
    'source-layer': 'zoning_riverside_city_ca',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)", // Ensure outline is visible
        "fill-opacity": 0.8, // Increase opacity for better visibility
        "fill-color": '#ea60f5' // Ensure color is distinct
    }
};

const zoningYorkCountyPaLayer: FillLayer = {
    id: 'zoningYorkCountyPa',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.0luqtag4',
    'source-layer': 'zoning_york_county_pa-d3o6z4',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#ea60f5',
    }
};

const zoningLucasCountyOhLayer: FillLayer = {
    'id': 'zoningLucasCountyOh',
    'type': 'fill',
    'source': 'mapbox://ceascreeningtooldev.zoning_lucas_county_oh',
    'source-layer': 'zoning_lucas_county_oh',
    'metadata': {
        uidField: 'PARID'
    },
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0.2,
        "fill-color": '#e7051b',
    }
};

const agLandKauaiHiLayer: FillLayer = {
    id: 'agLandKauaiHi',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.ag_land_use_kauai_hi',
    'source-layer': 'ag_land_use_kauai_hi',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#dce306',
    }
};

const agLandImportantKauaiHiLayer: FillLayer = {
    id: 'agLandImportantKauaiHi',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.important_ag_lands_kauai_hi',
    'source-layer': 'important_ag_lands_kauai_hi',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#ffffff',
    }
};

const freightNetworkLayer: LineLayer = {
    id: 'freightNetwork',
    type: 'line',
    source: 'mapbox://ceascreeningtooldev.us_freight_routes',
    'source-layer': 'us_freight_routes',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "line-color": "rgb(100, 118, 231)",
        "line-opacity": 0.9,
        "line-width": 2,
    }
};

const wtrSrvcAreasUs: FillLayer = {
    id: 'wtrSrvcAreasUs',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.654h7i5k',
    'source-layer': 'comm_wtr_sys_srvc_areas',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0.0,
        "fill-color": '#1c4eda'
    }
};

const wtrLinesRiversideCountyCaLayer: LineLayer = {
    id: 'wtrLinesRiversideCountyCa',
    type: 'line',
    source: 'mapbox://ceascreeningtooldev.4pikr3rz',
    'source-layer': 'wtr_lines_riverside_ca',
    'layout': {
        'visibility': 'visible'
    },
    paint: {
        'line-color': '#1c4eda',
        'line-opacity': 0.9,
        "line-width": 1,
    }
};

const wtrLinesMainsLucasCountyOhLayer: LineLayer = {
    id: 'wtrLinesMainsLucasCountyOh',
    type: 'line',
    source: 'mapbox://ceascreeningtooldev.water_mains_lucas_county_oh',
    'source-layer': 'water_mains_lucas_county_oh',
    'layout': {
        'visibility': 'visible'
    },
    paint: {
        'line-color': '#141dce',
        'line-opacity': 0.8,
        "line-width": 1.6,
    }
};

const wtrLinesLateralsLucasCountyOhLayer: LineLayer = {
    id: 'wtrLinesLateralsLucasCountyOh',
    type: 'line',
    source: 'mapbox://ceascreeningtooldev.water_laterals_lucas_county_oh',
    'source-layer': 'water_laterals_lucas_county_oh',
    'layout': {
        'visibility': 'visible'
    },
    paint: {
        'line-color': '#141dce',
        'line-opacity': 0.8,
        "line-width": 1.6,
    }
};

const wtrRatesYorkCountyPaLayer: FillLayer = {
    id: 'wtrRatesYorkCountyPa',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.water_rates_york_county_pa',
    'source-layer': 'water_rates_york_county_pa',
    'layout': {
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgb(236,232,232)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#141dce',
    }
};

const wtrRatesKauaiHiLayer: FillLayer = {
    id: 'wtrRatesKauaiHi',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.water_rates_kauai_hi',
    'source-layer': 'water_rates_kauai_hi',
    'layout': {
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgb(236,232,232)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#141dce',
    }
};

const wtrRatesAugustaGaLayer: FillLayer = {
    id: 'wtrRatesAugustaGa',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.water_service_areas_augusta_ga',
    'source-layer': 'water_service_areas_augusta_ga',
    'layout': {
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgb(236,232,232)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#141dce',
    }
};

const wtrRatesWLERLayer: FillLayer = {
    id: 'wtrRatesWLER',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.water_rates_wler',
    'source-layer': 'water_rates_wler',
    'layout': {
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgb(236,232,232)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#141dce',
    }
};

const wtrRatesRiversideCaLayer: FillLayer = {
    id: 'wtrRatesRiversideCa',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.water_rates_riverside_ca',
    'source-layer': 'water_rates_riverside_ca',
    'layout': {
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgb(236,232,232)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#141dce',
    }
};

const wastewaterSrvcAreasLucasCountyOh: FillLayer = {
    id: 'wastewaterSrvcAreasLucasCountyOh',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.sewer_srvc_areas_lucas_county_oh',
    'source-layer': 'sewer_srvc_areas_lucas_county_oh',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0,
        "fill-color": '#1c4eda'
    }
};

const wastewaterSrvcAreasAugustaGa: FillLayer = {
    id: 'wastewaterSrvcAreasAugustaGa',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.sewer_service_areas_augusta_ga',
    'source-layer': 'sewer_service_areas_augusta_ga',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0,
        "fill-color": '#1c4eda'
    }
};

const wastewaterSrvcAreasRiversideCountyCa: FillLayer = {
    id: 'wastewaterSrvcAreasRiversideCountyCa',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.0kwmc40v',
    'source-layer': 'wastewater_srvc_areas_riverside_ca',
    'layout': {
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgb(236,232,232)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#141dce',
    }
};

const wastewaterLinesKauaiHiLayer: LineLayer = {
    id: 'wastewaterLinesKauaiHi',
    type: 'line',
    source: 'mapbox://ceascreeningtooldev.sewer_lines_kauai_hi',
    'source-layer': 'sewer_lines_kauai_hi',
    'layout': {
        'visibility': 'visible'
    },
    paint: {
        'line-color': '#141dce',
        'line-opacity': 0.8,
        "line-width": 1.6,
    }
};

const wastewaterLinesForceMainsLucasCountyOhLayer: LineLayer = {
    id: 'wastewaterLinesForceMainsLucasCountyOh',
    type: 'line',
    source: 'mapbox://ceascreeningtooldev.sewer_force_mains_lucas_oh',
    'source-layer': 'sewer_force_mains_lucas_oh',
    'layout': {
        'visibility': 'visible'
    },
    paint: {
        'line-color': '#141dce',
        'line-opacity': 0.8,
        "line-width": 1.6,
    }
};

const wastewaterLinesLateralsLucasCountyOhLayer: LineLayer = {
    id: 'wastewaterLinesLateralsLucasCountyOh',
    type: 'line',
    source: 'mapbox://ceascreeningtooldev.sewer_laterals_lucas_oh',
    'source-layer': 'sewer_laterals_lucas_oh',
    'layout': {
        'visibility': 'visible'
    },
    paint: {
        'line-color': '#141dce',
        'line-opacity': 0.8,
        "line-width": 1.6,
    }
};

const wastewaterLinesGravityMainsLucasCountyOhLayer: LineLayer = {
    id: 'wastewaterLinesGravityMainsLucasCountyOh',
    type: 'line',
    source: 'mapbox://ceascreeningtooldev.sewer_gravity_mains_lucas_oh',
    'source-layer': 'sewer_gravity_mains_lucas_oh',
    'layout': {
        'visibility': 'visible'
    },
    paint: {
        'line-color': '#141dce',
        'line-opacity': 0.8,
        "line-width": 1.6,
    }
};

const wastewaterLinesJacksonCountyGaLayer: LineLayer = {
    id: 'wastewaterLinesJacksonCountyGa',
    type: 'line',
    source: 'mapbox://ceascreeningtooldev.sewer_lines_jackson_county_ga',
    'source-layer': 'sewer_lines_jackson_county_ga',
    'layout': {
        'visibility': 'visible'
    },
    paint: {
        'line-color': '#141dce',
        'line-opacity': 0.8,
        "line-width": 1.6,
    }
};

const wastewaterLinesRiversideCountyCaLayer: LineLayer = {
    id: 'wastewaterLinesRiversideCountyCa',
    type: 'line',
    source: 'mapbox://ceascreeningtooldev.b4z9qser',
    'source-layer': 'wastewater_mains_riverside_ca_prod',
    'layout': {
        'visibility': 'visible'
    },
    paint: {
        'line-color': '#141dce',
        'line-opacity': 0.8,
        "line-width": 1.6,
    }
};

const wastewaterTreatPlantsKauaiHiLayer: CircleLayer = {
    id: 'wastewaterTreatPlantsKauaiHi',
    type: 'circle',
    source: 'mapbox://ceascreeningtooldev.wastewater_treat_plants_kauai_hi',
    'source-layer': 'wastewater_treat_plants_kauai_hi',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    paint: {
        'circle-radius': {stops: circRadStops},
        // 'circle-radius': 2,
        'circle-color': '#44bdf1',
        'circle-opacity': 0.9,
        'circle-stroke-color': '#ffffff',
        'circle-stroke-width': circStrokeWidth
    }
};

const wastewaterTreatPlantsLayer: CircleLayer = {
    id: 'wastewaterTreatPlants',
    type: 'circle',
    source: 'mapbox://ceascreeningtooldev.boam40yy',
    'source-layer': 'wastewater_treatment_plants-0bv90z',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    paint: {
        'circle-radius': {stops: circRadStops},
        // 'circle-radius': 2,
        'circle-color': '#44bdf1',
        'circle-opacity': 0.9,
        'circle-stroke-color': '#ffffff',
        'circle-stroke-width': circStrokeWidth
    }
};

const onsiteSewageDisposalKauaiHiLayer: CircleLayer = {
    id: 'onsiteSewageDisposalKauaiHi',
    type: 'circle',
    source: 'mapbox://ceascreeningtooldev.onsite_sewage_disposal_kauai_hi',
    'source-layer': 'onsite_sewage_disposal_kauai_hi',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    paint: {
        'circle-radius': {stops: circRadStops},
        // 'circle-radius': 2,
        'circle-color': '#44bdf1',
        'circle-opacity': 0.9,
        'circle-stroke-color': '#ffffff',
        'circle-stroke-width': circStrokeWidth
    }
};

const natGasLinesLayer: LineLayer = {
    id: 'natGasLines',
    type: 'line',
    source: 'mapbox://ceascreeningtooldev.6dxfw8oq',
    'source-layer': 'Natural_Gas_Liquid_Pipelines_-95uytx',
    'layout': {
        'visibility': 'visible'
    },
    paint: {
        'line-color': '#1c4eda',
        'line-opacity': 0
    }
};

const natGasPriceExpr =
    [
        'get',
        ['string', ['get', 'State']],
        ['literal', natGasPriceData]
    ]

const natGasPriceLayer: FillLayer = {
    id: 'natGasPrice',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.natural_gas_rates',
    'source-layer': 'natural_gas_rates',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0.0,
        // "fill-color": '#ceb514'
        'fill-color': [
            "interpolate",
            ["linear"],
            natGasPriceExpr,
            0, '#1cda1f',
            10, '#f7e600',
            20, '#ff1111', 
        ],
    }
};

const elecPwrTransLines: LineLayer = {
    id: 'elecPwrTransLines',
    type: 'line',
    source: 'mapbox://ceascreeningtooldev.2hnyzfqr',
    'source-layer': 'us_power_trans_lines',
    'layout': {
        'visibility': 'visible'
    },
    paint: {
        'line-color': '#ce145e',
        'line-opacity': 0
    }
};

const elecPriceExpr =
    [
        'get',
        ['string', ['get', 'Zip Code']],
        ['literal', elecPriceData]
    ]

const elecPriceLayer: FillLayer = {
    id: 'elecPrice',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.electricity_rates',
    'source-layer': 'electricity_rates',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0.0,
        // "fill-color": '#ceb514'
        'fill-color': [
            "interpolate",
            ["linear"],
            elecPriceExpr,
            0, '#1cda1f',
            0.125, '#f7e600',
            0.25, '#ff1111', 
        ],
    }
};

const microgridsLayer: CircleLayer = {
    id: 'microgrids',
    type: 'circle',
    source: 'mapbox://ceascreeningtooldev.microgrid_facilities',
    'source-layer': 'microgrid_facilities',
    'layout': {
        'visibility': 'visible'
    },
    paint: {
        // 'circle-radius': circRad,
        'circle-radius': {stops: circRadStops},
        'circle-color': '#ce7714',
        'circle-opacity': 0.9,
        'circle-stroke-color': '#ffffff',
        'circle-stroke-width': circStrokeWidth
    }
};

const chpPlantsLayer: CircleLayer = {
    id: 'chpPlants',
    type: 'circle',
    source: 'mapbox://ceascreeningtooldev.chp_facilities',
    'source-layer': 'chp_facilities',
    'layout': {
        'visibility': 'visible'
    },
    paint: {
        // 'circle-radius': circRad,
        'circle-radius': {stops: circRadStops},
        'circle-color': '#ce7714',
        'circle-opacity': 0.9,
        'circle-stroke-color': '#ffffff',
        'circle-stroke-width': circStrokeWidth
    }
};

const substationsLayer: CircleLayer = {
    id: 'substations',
    type: 'circle',
    source: 'mapbox://ceascreeningtooldev.substations',
    'source-layer': 'substations',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    paint: {
        'circle-radius': {stops: circRadStops},
        // 'circle-radius': 2,
        'circle-color': '#44bdf1',
        'circle-opacity': 0.9,
        'circle-stroke-color': '#ffffff',
        'circle-stroke-width': circStrokeWidth
    }
};

const outagesExpr =
    [
        'get',
        ['string', ['get', 'GEOID']],
        ['literal', outagesData]
    ]

const outagesLayer: FillLayer = {
    id: 'outages',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.outages',
    'source-layer': 'outages',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(89,92,92,0.9)",
        "fill-opacity": 0.0,
        // "fill-color": '#ceb514'
        'fill-color': [
            "interpolate",
            ["linear"],
            outagesExpr,
            0, '#1cda1f',
            1000000, "yellow", 
            157542917, '#ff1111',
        ],
    }
};


// Social and economic layers
const popDensityExpr =
    [
        'get',
        ['string', ['get', 'GEOID']],
        ['literal', popDensityData]
    ]

const popDensityLayer: FillLayer = {
    id: 'popDensity',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.5qjujhg0',
    'source-layer': 'us_counties-61dw47',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    paint: {
        "fill-outline-color": "rgba(255, 255, 255, 1)",
        'fill-opacity': 0,
        'fill-color': [
            "interpolate",
            ["linear"],
            popDensityExpr,
            1, '#0109a7',
            20, '#0131ad',
            40, '#015cb3',
            60, '#018ab9',
            80, '#01bbc0',
            100, '#01c69c',
            120, '#01cc72',
            140, '#01d245',
            160, '#01d815',
            180, '#20de01',
            200, '#56e501',
            250, '#8eeb00',
            300, '#caf100',
            350, '#f7e600',
            400, '#fdb100',
            450, '#ff7905',
            650, '#ff440b',
            900, '#ff1111'
        ],
    }
};

const incomeExpr =
    [
        'get',
        ['string', ['get', 'GEOID']],
        ['literal', incomeData]
    ]

const incomeLayer: FillLayer = {
    id: 'income',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.income',
    'source-layer': 'income',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    paint: {
        "fill-outline-color": "rgba(255, 255, 255, 1)",
        'fill-opacity': 0,
        'fill-color': [
            "interpolate",
            ["linear"],
            incomeExpr,
            30000, '#c74803',
            100000, '#1cda1f',
            200000, '#1c4eda',
        ],
    }
};

const ceaWorkersLayer: FillLayer = {
    id: 'ceaWorkers',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.cea_workers',
    'source-layer': 'cea_workers',
    'layout': {
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgb(236,232,232)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#141dce',
    }
};

const ceaWagesLayer: FillLayer = {
    id: 'ceaWages',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.cea_wages',
    'source-layer': 'cea_wages',
    'layout': {
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgb(236,232,232)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#141dce',
    }
};

const warehouseWorkersLayer: FillLayer = {
    id: 'warehouseWorkers',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.warehouse_workers',
    'source-layer': 'warehouse_workers',
    'layout': {
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgb(236,232,232)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#141dce',
    }
};

const unemployExpr =
    [
        'get',
        ['string', ['get', 'GEOID']],
        ['literal', unemployData]
    ]

const unemployLayer: FillLayer = {
    id: 'unemploy',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.unemployment_rate',
    'source-layer': 'unemployment_rate',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    paint: {
        "fill-outline-color": "rgba(255, 255, 255, 1)",
        'fill-opacity': 0,
        'fill-color': [
            "interpolate",
            ["linear"],
            unemployExpr,
            0, '#1cda1f',
            20, '#ff1111',
        ],
    }
};

const edLayer: FillLayer = {
    id: 'education',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.education',
    'source-layer': 'education',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0.0,
        "fill-color": '#1c4eda'
    }
};

const edPopLessThanHsExpr =
    [
        'get',
        ['string', ['get', 'GEOID']],
        ['literal', edPopLessThanHsData]
    ]

const edPopLessThanHsLayer: FillLayer = {
    id: 'edPopLessThanHs',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.5qjujhg0',
    'source-layer': 'us_counties-61dw47',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    paint: {
        "fill-outline-color": "rgba(255, 255, 255, 1)",
        'fill-opacity': 0,
        'fill-color': [
            "interpolate",
            ["linear"],
            edPopLessThanHsExpr,
            1, '#0109a7',
            20, '#0131ad',
            40, '#015cb3',
            60, '#018ab9',
            80, '#01bbc0',
            100, '#01c69c',
            120, '#01cc72',
            140, '#01d245',
            160, '#01d815',
            180, '#20de01',
            200, '#56e501',
            250, '#8eeb00',
            300, '#caf100',
            350, '#f7e600',
            400, '#fdb100',
            450, '#ff7905',
            650, '#ff440b',
            900, '#ff1111'
        ],
    }
};

const edPopBachelorsOrHigherExpr =
    [
        'get',
        ['string', ['get', 'GEOID']],
        ['literal', edPopBachelorsOrHigherData]
    ]

const edPopBachelorsOrHigherLayer: FillLayer = {
    id: 'edPopBachelorsOrHigher',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.5qjujhg0',
    'source-layer': 'us_counties-61dw47',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    paint: {
        "fill-outline-color": "rgba(255, 255, 255, 1)",
        'fill-opacity': 0,
        'fill-color': [
            "interpolate",
            ["linear"],
            edPopBachelorsOrHigherExpr,
            1, '#0109a7',
            20, '#0131ad',
            40, '#015cb3',
            60, '#018ab9',
            80, '#01bbc0',
            100, '#01c69c',
            120, '#01cc72',
            140, '#01d245',
            160, '#01d815',
            180, '#20de01',
            200, '#56e501',
            250, '#8eeb00',
            300, '#caf100',
            350, '#f7e600',
            400, '#fdb100',
            450, '#ff7905',
            650, '#ff440b',
            900, '#ff1111'
        ],
    }
};

const edPopHsOrHigherExpr =
    [
        'get',
        ['string', ['get', 'GEOID']],
        ['literal', edPopHsOrHigherData]
    ]

const edPopHsOrHigherLayer: FillLayer = {
    id: 'edPopHsOrHigher',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.5qjujhg0',
    'source-layer': 'us_counties-61dw47',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    paint: {
        "fill-outline-color": "rgba(255, 255, 255, 1)",
        'fill-opacity': 0,
        'fill-color': [
            "interpolate",
            ["linear"],
            edPopHsOrHigherExpr,
            1, '#0109a7',
            20, '#0131ad',
            40, '#015cb3',
            60, '#018ab9',
            80, '#01bbc0',
            100, '#01c69c',
            120, '#01cc72',
            140, '#01d245',
            160, '#01d815',
            180, '#20de01',
            200, '#56e501',
            250, '#8eeb00',
            300, '#caf100',
            350, '#f7e600',
            400, '#fdb100',
            450, '#ff7905',
            650, '#ff440b',
            900, '#ff1111'
        ],
    }
};

const opportunityZonesAugustaGa: FillLayer = {
    id: 'opportunityZonesAugustaGa',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.opportunity_zones_augusta_ga',
    'source-layer': 'opportunity_zones_augusta_ga',
    'layout': {
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgb(236,232,232)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#141dce',
    }
};

const opportunityZones: FillLayer = {
    id: 'opportunityZones',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.71ibo0uc',
    'source-layer': 'opportunity_zones',
    'layout': {
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgb(236,232,232)",
        "fill-opacity": 0,
        // "fill-color": '#ceb514'
        "fill-color": '#141dce',
    }
};

const foodAccessDataDict = {
    'LILATracts_1And10': "Low income and low access measured at 1 (urban) and 10 (rural) miles",
    'LILATracts_1And20': "Low income and low access measured at 1 (urban) and 20 (rural) miles",
    'LILATracts_halfAnd10': "Low income and low access measured at 1/2 (urban) and 10 (rural) miles",
    'LILATracts_Vehicle': "Low income and low access using vehicle access"
}
const foodAccessExpr =
    [
        'get',
        ['string', ['get', 'GEOID']],
        ['literal', foodAccessData]
    ]

const foodAccessLayer: FillLayer = {
    id: 'foodAccess',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.cf7lflc3',
    'source-layer': 'census_tracts',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(89,92,92,0.9)",
        "fill-opacity": 0.0,
        // "fill-color": '#ceb514'
        'fill-color': [
            "match",
            foodAccessExpr,
            'LILATracts_1And10', '#1e29ee',
            'LILATracts_halfAnd10', '#f5d404',
            'LILATracts_1And20', '#ff1111',
            'LILATracts_Vehicle', '#ee7823',
            '#ffffff'
        ],
    }
};


//Colocation opportunities layers
const ceaFacilitiesLayer: CircleLayer = {
    id: 'ceaFacilities',
    type: 'circle',
    source: 'mapbox://ceascreeningtooldev.cea_facilities',
    'source-layer': 'cea_facilities',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    paint: {
        // 'circle-radius': circRad,
        'circle-radius': {stops: circRadStops},
        'circle-color': '#1c4eda',
        'circle-opacity': 0.9,
        'circle-stroke-color': '#ffffff',
        'circle-stroke-width': circStrokeWidth
    }
};

const compostFacilitiesLayer: CircleLayer = {
    id: 'compostFacilities',
    type: 'circle',
    source: 'mapbox://ceascreeningtooldev.3wu9azkl',
    'source-layer': 'composting_facilities_epa',
    'layout': {
        'visibility': 'visible'
    },
    paint: {
        // 'circle-radius': circRad,
        'circle-radius': {stops: circRadStops},
        'circle-color': '#1cda1f',
        'circle-opacity': 0.9,
        'circle-stroke-color': '#ffffff',
        'circle-stroke-width': circStrokeWidth
    }
};

const foodBanksLayer: CircleLayer = {
    id: 'foodBanks',
    type: 'circle',
    source: 'mapbox://ceascreeningtooldev.43ve38pj',
    'source-layer': 'food_banks_epa',
    'layout': {
        'visibility': 'visible'
    },
    paint: {
        // 'circle-radius': circRad,
        'circle-radius': {stops: circRadStops},
        'circle-color': '#bc36c6',
        'circle-opacity': 0.9,
        'circle-stroke-color': '#ffffff',
        'circle-stroke-width': circStrokeWidth
    }
};

const foodManufactProcessorsLayer: CircleLayer = {
    id: 'foodManufactProcessors',
    type: 'circle',
    source: 'mapbox://ceascreeningtooldev.4j9qtydh',
    'source-layer': 'food_manufactureres_and_processors_epa',
    'layout': {
        'visibility': 'visible'
    },
    paint: {
        // 'circle-radius': circRad,
        'circle-radius': {stops: circRadStops},
        'circle-color': '#5b3e40',
        'circle-opacity': 0.9,
        'circle-stroke-color': '#ffffff',
        'circle-stroke-width': circStrokeWidth
    }
};

const refrigFacilitiesLayer: CircleLayer = {
    id: 'refrigFacilities',
    type: 'circle',
    source: 'mapbox://ceascreeningtooldev.ab5153jc',
    'source-layer': 'refrig_warehouses_and_storage_epa',
    'layout': {
        'visibility': 'visible'
    },
    paint: {
        // 'circle-radius': circRad,
        'circle-radius': {stops: circRadStops},
        'circle-color': '#10cadc',
        'circle-opacity': 0.9,
        'circle-stroke-color': '#ffffff',
        'circle-stroke-width': circStrokeWidth
    }
};

const farmersMarketsLayer: CircleLayer = {
    id: 'farmersMarkets',
    type: 'circle',
    source: 'mapbox://ceascreeningtooldev.b2g5mdyw',
    'source-layer': 'farmers_markets_usda',
    'layout': {
        'visibility': 'visible'
    },
    paint: {
        // 'circle-radius': circRad,
        'circle-radius': {stops: circRadStops},
        'circle-color': '#ce7714',
        'circle-opacity': 0.9,
        'circle-stroke-color': '#ffffff',
        'circle-stroke-width': circStrokeWidth
    }
};

const collegesUnisLayer: CircleLayer = {
    id: 'collegesUnis',
    type: 'circle',
    source: 'mapbox://ceascreeningtooldev.colleges_universities',
    'source-layer': 'colleges_universities',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    paint: {
        // 'circle-radius': circRad,
        'circle-radius': {stops: circRadStops},
        'circle-color': '#1c4eda',
        'circle-opacity': 0.9,
        'circle-stroke-color': '#ffffff',
        'circle-stroke-width': circStrokeWidth
    }
};

const pwrPlantsLayer: CircleLayer = {
    id: 'pwrPlants',
    type: 'circle',
    source: 'mapbox://ceascreeningtooldev.5bvdt1xw',
    'source-layer': 'power_plants',
    'layout': {
        'visibility': 'visible'
    },
    paint: {
        // 'circle-radius': circRad,
        'circle-radius': {stops: circRadStops},
        'circle-color': '#e7051b',
        'circle-opacity': 0.9,
        'circle-stroke-color': '#ffffff',
        'circle-stroke-width': circStrokeWidth
    }
};
const supermarketsLayer: SymbolLayer = {
    id: 'supermarkets',
    type: 'symbol',
    metadata: {
        'icon-svg': 'MdLocalGroceryStore.svg'
    },
    interactive: true,
    source: 'mapbox://ceascreeningtooldev.food_wholesalers_and_retailers',
    'source-layer': 'food_wholesalers_and_retailers',
    layout: {
        'icon-image':
            [
                // Use the 'match' expression:
                // https://docs.mapbox.com/style-spec/reference/expressions/#match
                'match',
                ['get', 'NAICS Code Description'],
                'Supermarkets and Other Grocery (except Convenience) Stores',
                `shop-cart-icon`,
                '',
            ],
        'icon-size': {stops: iconSizeStops},
        'icon-allow-overlap': true,
        'symbol-avoid-edges': true,
        'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
        'text-size': 8,
        'text-transform': 'uppercase',
        'text-letter-spacing': 0.05,
        'text-offset': [0, 1.3],
    },
    // filter: ['==', 'PIN', selectedParcelData.parcelId]
    paint: {
        'icon-opacity': 0.5
    },
}

const fruitVegMarketsLayer: SymbolLayer = {
    id: 'fruitVegMarkets',
    type: 'symbol',
    interactive: true,
    source: 'mapbox://ceascreeningtooldev.food_wholesalers_and_retailers',
    'source-layer': 'food_wholesalers_and_retailers',
    layout: {
        'icon-image':
            [
                // Use the 'match' expression:
                // https://docs.mapbox.com/style-spec/reference/expressions/#match
                'match',
                ['get', 'NAICS Code Description'],
                'Fruit and Vegetable Markets',
                `shop-basket-icon`,
                '',
            ],
        'icon-size': {stops: iconSizeStops},
        'icon-allow-overlap': true,
        'symbol-avoid-edges': true,
        'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
        'text-size': 8,
        'text-transform': 'uppercase',
        'text-letter-spacing': 0.05,
        'text-offset': [0, 1.3],
    },
    // filter: ['==', 'PIN', selectedParcelData.parcelId]
    paint: {
        'icon-opacity': 0.5
    },
}

const fruitVegWholesalersLayer: SymbolLayer = {
    id: 'fruitVegWholesalers',
    type: 'symbol',
    interactive: true,
    source: 'mapbox://ceascreeningtooldev.food_wholesalers_and_retailers',
    'source-layer': 'food_wholesalers_and_retailers',
    layout: {
        'icon-image':
            [
                // Use the 'match' expression:
                // https://docs.mapbox.com/style-spec/reference/expressions/#match
                'match',
                ['get', 'NAICS Code Description'],
                'Fresh Fruit and Vegetable Merchant Wholesalers',
                `fruits-pear-icon`,
                '',
            ],
        'icon-size': {stops: iconSizeStops},
        'icon-allow-overlap': true,
        'symbol-avoid-edges': true,
        'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
        'text-size': 8,
        'text-transform': 'uppercase',
        'text-letter-spacing': 0.05,
        'text-offset': [0, 1.3],
    },
    // filter: ['==', 'PIN', selectedParcelData.parcelId]
    paint: {
        'icon-opacity': 0.5
    },
}

const warehouseClubsLayer: SymbolLayer = {
    id: 'warehouseClubs',
    type: 'symbol',
    interactive: true,
    source: 'mapbox://ceascreeningtooldev.food_wholesalers_and_retailers',
    'source-layer': 'food_wholesalers_and_retailers',
    layout: {
        'icon-image':
            [
                // Use the 'match' expression:
                // https://docs.mapbox.com/style-spec/reference/expressions/#match
                'match',
                ['get', 'NAICS Code Description'],
                'Warehouse Clubs and Supercenters',
                'store-icon',
                '',
            ],
        'icon-size': {stops: iconSizeStops},
        'icon-allow-overlap': true,
        'symbol-avoid-edges': true,
        'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
        'text-size': 8,
        'text-transform': 'uppercase',
        'text-letter-spacing': 0.05,
        'text-offset': [0, 1.3],
    },
    // filter: ['==', 'PIN', selectedParcelData.parcelId]
    paint: {
        'icon-opacity': 0.5
    },
}

const generalWarehousingStorageLayer: SymbolLayer = {
    id: 'generalWarehousingStorage',
    type: 'symbol',
    interactive: true,
    source: 'mapbox://ceascreeningtooldev.food_wholesalers_and_retailers',
    'source-layer': 'food_wholesalers_and_retailers',
    layout: {
        'icon-image':
            [
                // Use the 'match' expression:
                // https://docs.mapbox.com/style-spec/reference/expressions/#match
                'match',
                ['get', 'NAICS Code Description'],
                'General Warehousing and Storage',
                'warehouse-icon',
                '',
            ],
        'icon-size': {stops: iconSizeStops},
        'icon-allow-overlap': true,
        'symbol-avoid-edges': true,
        'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
        'text-size': 8,
        'text-transform': 'uppercase',
        'text-letter-spacing': 0.05,
        'text-offset': [0, 1.3],
    },
    // filter: ['==', 'PIN', selectedParcelData.parcelId]
    paint: {
        'icon-opacity': 0.5
    },
}

// const foodRetailersLayer: SymbolLayer = {
//     id: 'foodRetailers',
//     type: 'symbol',
//     interactive: true,
//     source: 'mapbox://ceascreeningtooldev.food_wholesalers_and_retailers',
//     'source-layer': 'food_wholesalers_and_retailers',
//     layout: {
//         'icon-image':
//             [
//                 // Use the 'match' expression:
//                 // https://docs.mapbox.com/style-spec/reference/expressions/#match
//                 'match',
//                 ['get', 'NAICS Code Description'],
//                 'Supermarkets and Other Grocery (except Convenience) Stores',
//                 `store-icon`,
//                 'Fruit and Vegetable Markets',
//                 `shop-basket-icon`,
//                 'Fresh Fruit and Vegetable Merchant Wholesalers',
//                 `fruits-pear-icon`,
//                 'Warehouse Clubs and Supercenters',
//                 'shop-cart-icon',
//                 'General Warehousing and Storage',
//                 'warehouse-icon',
//                 '',
//             ],
//         'icon-size': {stops: iconSizeStops},
//         'icon-allow-overlap': true,
//         'symbol-avoid-edges': true,
//         'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
//         'text-size': 8,
//         'text-transform': 'uppercase',
//         'text-letter-spacing': 0.05,
//         'text-offset': [0, 1.3],
//     },
//     // filter: ['==', 'PIN', selectedParcelData.parcelId]
//     paint: {
//         'icon-opacity': 0.5
//     },
// }

const anaerobDigestersLayer: CircleLayer = {
    id: 'anaerobDigesters',
    type: 'circle',
    source: 'mapbox://ceascreeningtooldev.7w8hntpr',
    'source-layer': 'anaerobic_digesters_epa',
    'layout': {
        'visibility': 'visible'
    },
    paint: {
        // 'circle-radius': circRad,
        'circle-radius': {stops: circRadStops},
        'circle-color': '#164d17',
        'circle-opacity': 0.9,
        'circle-stroke-color': '#ffffff',
        'circle-stroke-width': circStrokeWidth
    }
};

const landfillsLayer: CircleLayer = {
    id: 'landfills',
    type: 'circle',
    source: 'mapbox://ceascreeningtooldev.33f35aas',
    'source-layer': 'landfills_mop_prod-2zpccw',
    'layout': {
        'visibility': 'visible'
    },
    paint: {
        // 'circle-radius': circRad,
        'circle-radius': {stops: circRadStops},
        'circle-color': '#4b3638',
        'circle-opacity': 0.9,
        'circle-stroke-color': '#ffffff',
        'circle-stroke-width': circStrokeWidth
    }
};

// Layers needed for dependencies
const countiesLayer: FillLayer = {
    id: 'counties',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.5qjujhg0',
    'source-layer': 'us_counties-61dw47',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(220,217,217,0.8)",
        "fill-opacity": 0.0,
        // "fill-color": '#ceb514'
        "fill-color": '#51e3d7',
    }
};
// Define fill layers with county boundary geometries.
const countyFillLayerIds = [
    'temperature',
    'precip',
    'airQual',
    'popDensity',
    'income',
    'unemploy',
    'heatDegDays',
    'coolDegDays',
    'edPopLessThanHs',
    'edPopHsOrHigher',
    'edPopBachelorsOrHigher',
]

// Define fill layers with zipcode geometries.
const zipcodeFillLayerIds = ['elecPrice']

const zipcodesLayer: FillLayer = {
    id: 'zipcodes',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.4dg18dvp',
    'source-layer': 'us_zipcodes',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0.0,
        // "fill-color": '#ceb514'
        "fill-color": '#bc36c6',
    }
};

// Define fill layers with census tract geometries.
const censusTractFillLayerIds = ['foodAccess', 'opportunityZones']

const censusTractsLayer: FillLayer = {
    id: 'censusTracts',
    type: 'fill',
    source: 'mapbox://ceascreeningtooldev.cf7lflc3',
    'source-layer': 'census_tracts',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "fill-outline-color": "rgba(26,25,25,0.8)",
        "fill-opacity": 0.0,
        // "fill-color": '#ceb514'
        "fill-color": '#bc36c6',
    }
};

// Parcel boundary layers for spotlight communities
const parcelBordersRiversideCountyCaLayer: LineLayer = {
    id: 'parcelBordersRiversideCountyCa',
    type: 'line',
    source: 'mapbox://ceascreeningtooldev.5xhocvwg',
    'source-layer': 'parcels_riverside_ca_prod',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "line-color": "rgb(255,255,255)",
        "line-opacity": 0.9,
        "line-width": 0.6,
    }
};

const parcelBordersKauaiCountyHiLayer: LineLayer = {
    id: 'parcelBordersKauaiCountyHi',
    type: 'line',
    source: landUseKauaiCountyHiLayer.source,
    'source-layer': landUseKauaiCountyHiLayer["source-layer"],
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "line-color": "rgb(255,255,255)",
        "line-opacity": 0.9,
        "line-width": 0.6,
    }
};

const parcelBordersLorainCountyOhLayer: LineLayer = {
    id: 'parcelBordersLorainCountyOh',
    type: 'line',
    source: landValueLorainCountyOhLayer.source,
    'source-layer': landValueLorainCountyOhLayer['source-layer'],
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "line-color": "rgb(255,255,255)",
        "line-opacity": 0.9,
        "line-width": 0.6,
    }
};

const parcelBordersMonroeCountyMiLayer: LineLayer = {
    id: 'parcelBordersMonroeCountyOh',
    type: 'line',
    source: landValueMonroeCountyMiLayer.source,
    'source-layer': landValueMonroeCountyMiLayer['source-layer'],
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "line-color": "rgb(255,255,255)",
        "line-opacity": 0.9,
        "line-width": 0.6,
    }
};

const parcelBordersErieCountyOhLayer: LineLayer = {
    id: 'parcelBordersErieCountyOh',
    type: 'line',
    source: landValueErieCountyOhLayer.source,
    'source-layer': landValueErieCountyOhLayer['source-layer'],
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "line-color": "rgb(255,255,255)",
        "line-opacity": 0.9,
        "line-width": 0.6,
    }
};

const parcelBordersWayneCountyOhLayer: LineLayer = {
    id: 'parcelBordersWayneCountyOh',
    type: 'line',
    source: landUseWayneCountyOhLayer.source,
    'source-layer': landUseWayneCountyOhLayer['source-layer'],
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "line-color": "rgb(255,255,255)",
        "line-opacity": 0.9,
        "line-width": 0.6,
    }
};

const parcelBordersWayneCountyMiLayer: LineLayer = {
    id: 'parcelBordersWayneCountyMi',
    type: 'line',
    source: landUseWayneCountyMiLayer.source,
    'source-layer': landUseWayneCountyMiLayer['source-layer'],
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "line-color": "rgb(255,255,255)",
        "line-opacity": 0.9,
        "line-width": 0.6,
    }
};

const parcelBordersOttawaCountyOhLayer: LineLayer = {
    id: 'parcelBordersOttawaCountyOh',
    type: 'line',
    source: landUseOttawaCountyOhLayer.source,
    'source-layer': landUseOttawaCountyOhLayer['source-layer'],
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "line-color": "rgb(255,255,255)",
        "line-opacity": 0.9,
        "line-width": 0.6,
    }
};

const parcelBordersLucasCountyOhLayer: LineLayer = {
    id: 'parcelBordersLucasCountyOh',
    type: 'line',
    source: landValueLucasCountyOhLayer.source,
    'source-layer': landValueLucasCountyOhLayer['source-layer'],
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "line-color": "rgb(255,255,255)",
        "line-opacity": 0.9,
        "line-width": 0.6,
    }
};

const parcelBordersYorkCountyPaLayer: LineLayer = {
    id: 'parcelBordersYorkCountyPa',
    type: 'line',
    source: 'mapbox://ceascreeningtooldev.1oac1z5s',
    'source-layer': 'york_county_pa_parcels',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "line-color": "rgb(255,255,255)",
        "line-opacity": 0.9,
        "line-width": 0.6,
    }
};

const parcelBordersRichmondCountyGaLayer: LineLayer = {
    id: 'parcelBordersRichmondCountyGa',
    type: 'line',
    source: 'mapbox://ceascreeningtooldev.parcels_augusta_ga',
    'source-layer': 'parcels_augusta_ga',
    'layout': {
        // Make the layer visible by default.
        'visibility': 'visible'
    },
    "paint": {
        "line-color": "rgb(255,255,255)",
        "line-opacity": 0.9,
        "line-width": 0.6,
    }
};

const INIT_FACILITY_PARAMS = {
    'type': 'Greenhouse',
    'size': 'Small',
    'tech': 'Low-tech',
    'crop': 'Tomatoes',
}
const INIT_ACTIVE_FACILITY_COLLAPSES = []
const INIT_ACTIVE_LAYER_COLLAPSES = []


// Order of layers in this array defines z-indexing. Layers at head of array
// are z-indexed below layers at the tail of the array. i.e. the first layer
// in the array is rendered as the bottom-most layer in the map, while the last
// layer in the array is rendered as the top-most. Ordering of layers affects
// behavior when they are clicked. For example, point layers that should
// trigger a popup opening on click events should be placed at the tail of this
// list so they effectively don't get 'covered/shielded' by fill (i.e.
// polygon) layers.
const INIT_LAYERS = [
    // Fill Layers (Polygons)
    foodAccessLayer,
    popDensityLayer,
    unemployLayer,
    edLayer,
    edPopLessThanHsLayer,
    edPopHsOrHigherLayer,
    edPopBachelorsOrHigherLayer,
    incomeLayer,
    countiesLayer,
    zipcodesLayer,
    censusTractsLayer,
    opportunityZones,
    ceaWorkersLayer,
    ceaWagesLayer,
    warehouseWorkersLayer,
    opportunityZonesAugustaGa,
    temperatureLayer,
    heatDegDaysLayer,
    coolDegDaysLayer,
    precipLayer,
    airQualLayer,
    agLandKauaiHiLayer,
    agLandImportantKauaiHiLayer,
    soilPropKauaiCountyHiLayer,
    soilPropUsLayer,
    solarInsolationLayer,
    windPowerClassLayer,
    geothermTempLayer,
    geothermTempKauaiLayer,
    climateZonesLayer,
    outagesLayer,
    elecPriceLayer,
    natGasPriceLayer,
    wtrSrvcAreasUs,
    wastewaterSrvcAreasLucasCountyOh,
    wastewaterSrvcAreasAugustaGa,
    wastewaterSrvcAreasRiversideCountyCa,
    zoningYorkCountyPaLayer,
    zoningRiversideCountyCaLayer,
    zoningRiversideCityCaLayer,
    zoningOttawaCountyOhLayer,
    zoningRichmondCountyGaLayer,
    zoningLorainCountyOhLayer,
    zoningFultonCountyOhLayer,
    zoningKauaiHiLayer,
    zoningLucasCountyOhLayer,
    wtrRatesAugustaGaLayer,
    wtrRatesRiversideCaLayer,
    wtrRatesYorkCountyPaLayer,
    wtrRatesKauaiHiLayer,
    wtrRatesWLERLayer,
    landUseYorkCountyPaLayer,
    landUseLucasCountyOhLayer,
    landUseOttawaCountyOhLayer,
    landUseRiversideCountyCaLayer,
    landUseWayneCountyMiLayer,
    landUseWayneCountyOhLayer,
    landUseErieCountyOhLayer,
    landUseLorainCountyOhLayer,
    landUseKauaiCountyHiLayer,
    landValueLucasCountyOhLayer,
    landValueOttawaCountyOhLayer,
    landValueYorkCountyPaLayer,
    landValueWayneCountyOhLayer,
    landValueErieCountyOhLayer,
    landValueLorainCountyOhLayer,
    landValueMonroeCountyMiLayer,
    landValueRiversideCountyCaLayer,
    parcelBordersLucasCountyOhLayer,
    parcelBordersOttawaCountyOhLayer,
    parcelBordersWayneCountyMiLayer,
    parcelBordersWayneCountyOhLayer,
    parcelBordersErieCountyOhLayer,
    parcelBordersMonroeCountyMiLayer,
    parcelBordersYorkCountyPaLayer,
    parcelBordersRiversideCountyCaLayer,
    parcelBordersRichmondCountyGaLayer,
    parcelBordersKauaiCountyHiLayer,
    // Line Layers
    freightNetworkLayer,
    elecPwrTransLines,
    natGasLinesLayer,
    wtrLinesRiversideCountyCaLayer,
    wtrLinesLateralsLucasCountyOhLayer,
    wtrLinesMainsLucasCountyOhLayer,
    wastewaterLinesForceMainsLucasCountyOhLayer,
    wastewaterLinesKauaiHiLayer,
    wastewaterLinesLateralsLucasCountyOhLayer,
    wastewaterLinesGravityMainsLucasCountyOhLayer,
    wastewaterLinesJacksonCountyGaLayer,
    wastewaterLinesRiversideCountyCaLayer,
    // Circle Layers
    wastewaterTreatPlantsLayer,
    onsiteSewageDisposalKauaiHiLayer,
    geothermWellsSpringsKauaiHiLayer,
    wastewaterTreatPlantsKauaiHiLayer,
    ceaFacilitiesLayer,
    collegesUnisLayer,
    landfillsLayer,
    compostFacilitiesLayer,
    pwrPlantsLayer,
    chpPlantsLayer,
    microgridsLayer,
    // foodRetailersLayer,
    generalWarehousingStorageLayer,
    warehouseClubsLayer,
    supermarketsLayer,
    fruitVegMarketsLayer,
    fruitVegWholesalersLayer,
    foodBanksLayer,
    farmersMarketsLayer,
    anaerobDigestersLayer,
    refrigFacilitiesLayer,
    foodManufactProcessorsLayer,
    geothermWellsSpringsLayer,
    substationsLayer
    //
]
// const INIT_BASELINE_RESULTS =
//     {
//         "energy": 4871,
//         "water": 2930,
//         "emissions": 3238,
//         "cost": 1459
//     }

const INIT_SELECTED_PARCEL_DATA: {
    parcelId: string;
    latitude?: number;
    longitude?: number;
    properties?: any;
    attrDict?: any;
    [key: string]: any; // To allow other properties from the feature
} = {
    "parcelId": "",
};

const INIT_SELECTED_CENSUS_TRACT_DATA =
    {
        "GEOID": "",
    }

const geoBoundaryLayerIds = ['counties', 'censusTracts', 'zipcodes']

const clickableLayerIds = [
    // Circle Layers
    'landfills',
    'wastewaterTreatPlants',
    'onsiteSewageDisposalKauaiHi',
    'wastewaterTreatPlantsKauaiHi',
    'ceaFacilities',
    'collegesUnis',
    'geothermWellsSpringsKauaiHi',
    'compostFacilities',
    'pwrPlants',
    'microgrids',
    'chpPlants',
    'foodRetailers',
    'generalWarehousingStorage',
    'warehouseClubs',
    'supermarkets',
    'fruitVegMarkets',
    'fruitVegWholesalers',
    'foodBanks',
    'farmersMarkets',
    'anaerobDigesters',
    'refrigFacilities',
    'foodManufactProcessors',
    'geothermWellsSprings',
    'substations',
    // Line Layers
    'wtrLinesRiversideCountyCa',
    'wtrLinesMainsLucasCountyOh',
    'wtrLinesLateralsLucasCountyOh',
    'wastewaterLinesForceMainsLucasCountyOh',
    'wastewaterLinesKauaiHi',
    'wastewaterLinesLateralsLucasCountyOh',
    'wastewaterLinesGravityMainsLucasCountyOh',
    'wastewaterLinesJacksonCountyGa',
    'wastewaterLinesRiversideCountyCa',
    'freightNetwork',
    // Fill Layers:
    'temperature',
    'heatDegDays',
    'coolDegDays',
    'precip',
    'geothermTemp',
    'geothermTempKauai',
    'airQual',
    'wtrSrvcAreasUs',
    'wastewaterSrvcAreasLucasCountyOh',
    'wastewaterSrvcAreasAugustaGa',
    'wastewaterSrvcAreasRiversideCountyCa',
    'soilPropUs',
    'soilPropKauaiCountyHi',
    'solarInsolation',
    'windPowerClassLayer',
    'climateZones',
    'foodAccess',
    'opportunityZones',
    'ceaWorkers',
    'ceaWages',
    'wtrRatesAugustaGa',
    'wtrRatesRiversideCa',
    'wtrRatesKauaiHi',
    'wtrRatesYorkCountyPa',
    'wtrRatesWLER',
    'warehouseWorkers',
    'opportunityZonesAugustaGa',
    'counties',
    'popDensity',
    'unemploy',
    'income',
    'agLandKauaiHi',
    'agLandImportantKauaiHi',
    'outages',
    'elecPrice',
    'natGasPrice',
    'education',
    'landValueYorkCountyPa',
    'landValueLucasCountyOh',
    'landValueOttawaCountyOh',
    'landValueErieCountyOh',
    'landValueMonroeCountyMi',
    'landValueLorainCountyOh',
    'landValueRiversideCountyCa',
    'landValueWayneCountyOh',
    'landUseLucasCountyOh',
    'landUseOttawaCountyOh',
    'landUseYorkCountyPa',
    'landUseErieCountyOh',
    'landUseLorainCountyOh',
    'landUseKauaiCountyHi',
    'landUseWayneCountyOh',
    'landUseWayneCountyMi',
    'landUseRiversideCountyCa',
    'zoningRiversideCountyCa',
    'zoningRiversideCityCa',
    'zoningYorkCountyPa',
    'zoningOttawaCountyOh',
    'zoningLucasCountyOh'
]

const layerPopups = {
    // -----------------------------------------------------------------------//
    // Circle Layers
    // -----------------------------------------------------------------------//
    'geothermWellsSprings': {
        'title': 'Geothermal Well/Spring',
        'attrDict': {
            "TEMP (DEGR": "Temperature (°C)",
            "SITE NAME": "Geothermal Well/Spring Name"
          }
    },
    
    'geothermWellsSpringsKauaiHi': {
        'title': 'Geothermal Spring',
        'attrDict':
            {
                "descriptio": "Geothermal Spring Name"

            }
    },
    
    'onsiteSewageDisposalKauaiHi': {
        'title': 'On-site Sewage Disposal System',
        'attrDict':
            {
                'tmk': 'Tax Map Key Number (TMK)',
                'effluent': 'Effluent Flux (MGD)',
                'source': 'Source'
            }
    },

    'wastewaterTreatPlantsKauaiHi': {
        'title': 'Wastewater Treatment Plant',
        'attrDict':
            {
                "WWTP_Name": "Wastewater Treatment Plant Name",
                "Owner_Type": "Owner Type",
                "Type": "Wastewater Treatment Plant Type"
            }
    },

    'wastewaterTreatPlants': {
        'title': 'Wastewater Treatment Plant',
        'attrDict': {
            "CWNS_ID": "Clean Watersheds Needs Survey ID",
            "FACILITY_NAME": "Facility Name"
        }
    },

    'chpPlants': {
        'title': 'CHP Plant',
        'attrDict':
            {
                "Facility Name": "Facility Name",
                "Application": "Application",
                "Latest Install Year": "Latest Install Year",
                "Capacity (kW)": "Capacity (kW)",
                "Prime Mover": "Prime Mover",
                "Fuel Class - Prim Fuel": "Fuel Class - Primary Fuel"
            }
    },

    'microgrids': {
        'title': 'Microgrid',
        'attrDict':
            {
                "Organization Name": "Organization",
                "Project Name": "Project Name",
                "Operational Year": "Operational Year",
                "Primary Appplication": "Primary Application",
                "Grid Connected": "Grid Connected",
                "Microgrid Type": "Microgrid Type",
                "Total Capacity (kW)": "Total Capacity (kW)",
                "Technologies": "Technologies"
            }
    },
    
    'substations': {
        'title': 'Electric Substation',
        'attrDict': {
            "id": "Substation ID",
            "NAME": "Substation Name",
            "STATUS":"Status",
        }
    },

    'ceaFacilities': {
        'title': 'CEA Facility',
        'attrDict': {
            "Grower": "Grower",
            "Address": "Address",
            "City": "City",
            "State": "State",
            "Zip": "Zipcode",
            "YearConst": "Year Constructed",
            "Crop": "Crop",
            "AreaSF": "Area (sq. ft)",

        }
    },

    'refrigFacilities': {
        'title': 'Refrigerated Storage Facility',
        'attrDict': {'Name':'Facility Name','Address':'Address','City': 'City','State':'State','Phone':'Phone Number','Website': 'Website'}
    },

    'compostFacilities': {
        'title': 'Composting Facility',
        'attrDict': {
            'Name': 'Name',
            'Type': 'Type',
            'Address': 'Address',
            'City': 'City',
            'State': 'State',
            'Zip_Code': 'Zipcode',
            'Feedstock': "Feedstock",
            'Food_Waste_Accepted_': "Food_Waste_Accepted_",
            'Phone': 'Phone Number',
            'Facility_s_Website': 'Website',
            'Source': "Source",
        }
    },

    'foodBanks': {
        'title': 'Food Bank',
        'attrDict': {
            'Name': 'Name',
            'Type': 'Type',
            'Address': 'Address',
            'City': 'City',
            'State': 'State',
            'Zip_Code': 'Zipcode',
            "Accepts_Food_Donations_": 'Accepts Food Donations',
            'Website': 'Website',

        }
    },

    'foodManufactProcessors': {
        'title': 'Food Manufacturer/Processor',
        'attrDict': {
            'Name': 'Name',
            'Type': 'Type',
            'Address': 'Address',
            'City': 'City',
            'State': 'State',
            'Zip_Code': 'Zipcode',
            'NAICS_Code': "NAICS Code",
            'ExcessFood': "Excess Food",
            'Phone1': 'Phone Number',
            'Website': 'Website',
        }
    },

    'farmersMarkets': {
        'title': "Farmer's Market",
        'attrDict': {
            'Name': 'Name',
            'Type': 'Type',
            'Address': 'Address',
            'City': 'City',
            'State': 'State',
            'Zipcode': 'Zipcode',
            'Operation_Dates': "Operation Dates",
            'Operation_Times': "Operation Times",
            'Website': 'Website',
        }
    },

    'collegesUnis': {
        'title': 'College/University',
        'attrDict': {
            "NAME": "Name",
            "ADDRESS": "Address",
            "CITY": "City",
            "STATE": "State",
            "ZIP": "Zipcode",
            "TOT_ENROLL": "Total Enrollment",
            "WEBSITE": "Website",

        }
    },

    'pwrPlants': {
        'title': 'Power Plant',
        'attrDict': {
            "Utility_Na": "Utility Name",
            "sector_nam": "Sector",
            "tech_desc": "Technical Description",
            "Plant_Name": "Plant Name"
        }
    },

    'supermarkets': {
        'title': 'Supermarket/Grocery Store',
        'attrDict': {
            'Name': 'Facility Name',
            'Type': 'Type',
            'Address': 'Address',
            'City': 'City',
            'State': 'State',
            'Zip Code': 'Zipcode',
            'Excess Food Estimate, Low (tons per year) ': "Low Estimate Excess Food (tons/year)",
            'Excess Food Estimate, High (tons per year) ': "High Estimate Excess Food (tons/year)",
            'Phone1': 'Phone Number',
            'Website': 'Website',

        }
    },

    'fruitVegMarkets': {
        'title': 'Fruit & Vegetable Market',
        'attrDict': {
            'Name': 'Name',
            'Type': 'Type',
            'Address': 'Address',
            'City': 'City',
            'State': 'State',
            'Zip Code': 'Zipcode',
            'Excess Food Estimate, Low (tons per year) ': "Low Estimate Excess Food (tons/year)",
            'Excess Food Estimate, High (tons per year) ': "High Estimate Excess Food (tons/year)",
            'Phone1': 'Phone Number',
            'Website': 'Website',

        }
    },

    'fruitVegWholesalers': {
        'title': 'Fruit & Vegetable Wholesaler',
        'attrDict': {
            'Name': 'Name',
            'Type': 'Type',
            'Address': 'Address',
            'City': 'City',
            'State': 'State',
            'Zip Code': 'Zipcode',
            'Excess Food Estimate, Low (tons per year) ': "Low Estimate Excess Food (tons/year)",
            'Excess Food Estimate, High (tons per year) ': "High Estimate Excess Food (tons/year)",
            'Phone1': 'Phone Number',
            'Website': 'Website',

        }
    },

    'warehouseClubs': {
        'title': 'Warehouse Club/Supercenter',
        'attrDict': {
            'Name': 'Name',
            'Type': 'Type',
            'Address': 'Address',
            'City': 'City',
            'State': 'State',
            'Zip Code': 'Zipcode',
            'Excess Food Estimate, Low (tons per year) ': "Low Estimate Excess Food (tons/year)",
            'Excess Food Estimate, High (tons per year) ': "High Estimate Excess Food (tons/year)",
            'Phone1': 'Phone Number',
            'Website': 'Website',

        }
    },

    'generalWarehousingStorage': {
        'title': 'General Warehousing/Storage Facility',
        'attrDict': {
            'Name': 'Name',
            'Type': 'Type',
            'Address': 'Address',
            'City': 'City',
            'State': 'State',
            'Zip Code': 'Zipcode',
            'Excess Food Estimate, Low (tons per year) ': "Low Estimate Excess Food (tons/year)",
            'Excess Food Estimate, High (tons per year) ': "High Estimate Excess Food (tons/year)",
            'Phone1': 'Phone Number',
            'Website': 'Website',

        }
    },

    'anaerobDigesters': {
        'title': 'Anaerobic Digester',
        'attrDict':
            {
                "FacilityType": "Facility Type",
                "Name": "Name",
                "Feedstock": "Feedstock",
                "Food_Waste_Accepted": "Food Waste Accepted?"
            },
    },

    'landfills': {
        'title': 'Landfill',
        'attrDict': {
            "landfill name": "Landfill Name",
            "composting?": "Composting?",
            "landfill operator organization":"Landfill Operator Organization",
            "current landfill status":"Current Landfill Status",
            "annual waste acceptance rate (tons per year)":"Annual Waste Acceptance Rate (tons per year)",
            "lfg collected (mmscfd)":"Landfill Gas Collected (mmscfd)"
          },
    },
    // -----------------------------------------------------------------------//
    // Line Layers
    // -----------------------------------------------------------------------//
    'freightNetwork': {
        'title': 'Freight Network',
        'attrDict':
            {
                'Class_Desc': 'Road Class',
                'Road_Name': 'Road Name',
                'Speed_Limi': 'Speed Limit',

            }
    },

    'wtrLinesRiversideCountyCa': {
        'title': 'Water Service Line',
        'attrDict': {}
    },

    'wtrLinesMainsLucasCountyOh': {
        'title': 'Water Service Main Line',
        'attrDict':
            {
                "Diameter": "Pipe Diameter (in)",
                "INSTALLYEA": "Installation Year",
                "Material": "Pipe Material",
                "Status": "Status",
                "Length": "Pipe Length (ft)"
            }

    },

    'wtrLinesLateralsLucasCountyOh': {
        'title': 'Water Service Lateral Line',
        'attrDict':
            {
                "MATERIAL": "Pipe Material",
                "DIAMETER": "Pipe Diameter (in)"
            }
    },

    'wastewaterLinesRiversideCountyCa': {
        'title': 'Wastewater Line',
        'attrDict': {'Operationa':'Operational Status',
            'PipeDiamet': 'Pipe Diameter (in)',
            'PipeMateri': 'Pipe Material',}
    },

    'wastewaterLinesForceMainsLucasCountyOh': {
        'title': 'Force Main Wastewater Line',
        'attrDict': {'MATERIAL':'Material',
            'DIAMETER':'Diameter (in)',
        }
    },

    'wastewaterLinesKauaiHi': {
        'title': 'Wastewater Line',
        'attrDict':
            {
            }
    },

    'wastewaterLinesLateralsLucasCountyOh': {
        'title': 'Lateral Wastewater Line',
        'attrDict': {'Diameter':'Diameter (in)',
            'Material':'Material'
        }
    },

    'wastewaterLinesGravityMainsLucasCountyOh': {
        'title': 'Gravity Main Wastewater Line',
        'attrDict': {'MATERIAL':'Material',
            'DIAMETER':'Diameter (in)',
        }
    },

    'wastewaterLinesJacksonCountyGa': {
        'title': 'Wastewater Line',
        'attrDict': {
        }
    },
    // -----------------------------------------------------------------------//
    // Fill Layers
    // -----------------------------------------------------------------------//
    'climateZones': {
        'title': 'Climate Zone',
        'attrDict': {
            "IECC_Climate_Zone": "IECC Climate Zone",
            "BA_Climate_Zone": "Building America Climate Zone",
            "IECC_Moisture_Regime": "IECC Moisture Regime"
        }
    },
    
    'temperature': {
        'title': 'Temperature',
        'attrDict': {
            'Value': 'Temperature (5-year mean) (°F)'
        }
    },

    'windPowerClass': {
        'title': 'Wind Power Class',
        'attrDict': {
            "WIND CLASS": "Wind Power Class"
        }
    },

    'solarInsolation': {
        'title': 'Solar Insolation',
        'attrDict': {
            "ANNUAL AVG": "Average Daily Solar Insolation (Wh/m²/day)"
        },
    },

    'geothermTemp': {
        'title': 'Geothermal Resource Area',
        'attrDict': {
            "ESTIMATED ": "Shallow Geothermal Resource Temperature (°C)"
        }
    },

    'geothermTempKauai': {
        'title': 'High-Temperature Resource Area',
        'attrDict': {
            "type ": "Geothermal Resource Type"
        }
    },

    'airQual': {
        'title': 'Air Quality Non-Attainment Zones',
        'attrDict': {
            "pollutant ": "Air Pollutant"
        }
    },


    'soilPropUs': {
        'title': 'Soil Properties',
        'attrDict': {"MUKEY": "Soil Unit Key",
            "MUSYM": "Soil Unit Symbol"
        }
    },
    
    'soilPropKauaiCountyHi': {
        'title': 'Soil Properties',
        'attrDict': {
            "SOILTYPE":"Soil Type",
            "FARMLAND":"Identified as Prime Farmland?"
          }
    },

    'landUseRiversideCountyCa': {
        'title': 'Land Use',
        'attrDict': {
            "LANDUSE": "General Plan Land Use Designation"
        }
    },

    'landUseYorkCountyPa': {
        'title': 'Land Use',
        'attrDict': {
            "ACRES": "Acres",
            "PARCEL": "Parcel ID",
            "LUC": "Land Use Code",
            "UTILITY": "Existing Utility Connections",
            "HEATSYS": "Heating System"
        }
    },

    'landUseOttawaCountyOh': {
        'title': 'Land Use',
        // TODO: Fill out `attrDict` below to define which layer attributes
        //  (keys) should appear in popup when a feature is clicked, and
        //  map each attribute to an informative label (values).
        'attrDict': {
            "TOWNSHIP": "Township",
            "Land_Use": "Land Use",
            "Parcel_Num":"Parcel Number",
            "Acres": "Acreage",
            "Class":"Land Use Class"
        }
    },

    'landUseWayneCountyOh': {
        'title': 'Land Use',
        // TODO: Fill out `attrDict` below to define which layer attributes
        //  (keys) should appear in popup when a feature is clicked, and
        //  map each attribute to an informative label (values).
        'attrDict': {
            "PIN": "Parcel Identification Number",
            "Township": "Township",
            "macres": "Acreage",
            "mlocAddr": "Address",
            "mlocCity": "City",
            "UseCode": "Land Use Code",
        }
    },

    'landUseWayneCountyMi': {
        'title': 'Land Use',
        // TODO: Fill out `attrDict` below to define which layer attributes
        //  (keys) should appear in popup when a feature is clicked, and
        //  map each attribute to an informative label (values).
        'attrDict': {
            "objectid": "Parcel ID",
            "landuse20": "Land Use Code"
        }
    },

    'landUseErieCountyOh': {
        'title': 'Land Use',
        // TODO: Fill out `attrDict` below to define which layer attributes
        //  (keys) should appear in popup when a feature is clicked, and
        //  map each attribute to an informative label (values).
        'attrDict': {
            "PIN": "Parcel Identification Number",
            "mlegalDesc": "Legal Description",
            "mlocCity": "City",
            "mlocState": "State",
            "mClassific":"Land Use"
        }
    },

    'landUseLorainCountyOh': {
        'title': 'Land Use',
        // TODO: Fill out `attrDict` below to define which layer attributes
        //  (keys) should appear in popup when a feature is clicked, and
        //  map each attribute to an informative label (values).
        'attrDict': {
            'PIN': "PIN",
            'mailing_ad': "Address",
            'class_code': "Land Use",
            'legal_desc': "Legal Description",
            'acres': "Acreage",

        }
    },

    'landUseLucasCountyOh': {
        'title': 'Land Use',
        // TODO: Fill out `attrDict` below to define which layer attributes
        //  (keys) should appear in popup when a feature is clicked, and
        //  map each attribute to an informative label (values).
        'attrDict': {
            'ACREAGE':'Acres',
            'LUC': "Land Use",
        }
    },
    
    'landUseKauaiCountyHi': {
        'title': 'Land Value',
        // TODO: Fill out `attrDict` below to define which layer attributes
        //  (keys) should appear in popup when a feature is clicked, and
        //  map each attribute to an informative label (values).
        'attrDict': {
            'parid': 'Parcel Number',
            'taxclass': 'Tax Class',
            'taxacres': 'Total Taxable Acres',
            'qpub_link': 'Link to More Parcel Info',
        }
    },

    'landValueYorkCountyPa': {
        'title': 'Land Value',
        'attrDict': {
            "ACRES": "Acres",
            "PARCEL": "Parcel ID",
            "APRBLDG": "Building Appraisal ($)",
            "APRLAND": "Land Appraisal ($)",
        }
    },

    'landValueOttawaCountyOh': {
        'title': 'Land Value',
        // TODO: Fill out `attrDict` below to define which layer attributes
        //  (keys) should appear in popup when a feature is clicked, and
        //  map each attribute to an informative label (values).
        'attrDict': {
            "TOWNSHIP": "Township",
            "Land_Use": "Land Use",
            "Parcel_Num":"Parcel Number",
            "Acres": "Acreage",
            "Appraised_": "Appraisal Value ($)",
        }
    },
    
    'landValueMonroeCountyMi': {
        'title': 'Land Value',
        // TODO: Fill out `attrDict` below to define which layer attributes
        //  (keys) should appear in popup when a feature is clicked, and
        //  map each attribute to an informative label (values).
        'attrDict': {
            "PARCELID": "Parcel ID",
            "STATEDAREA":"Acres",
            "LANDVAL": "Land Value ($)",
            "MUNICIPALITY": "Municipality"
        }
    },

    'landValueWayneCountyOh': {
        'title': 'Land Value',
        // TODO: Fill out `attrDict` below to define which layer attributes
        //  (keys) should appear in popup when a feature is clicked, and
        //  map each attribute to an informative label (values).
        'attrDict': {
            "PIN": "Parcel Identification Number",
            "Township": "Township",
            "macres": "Acreage",
            "mlocAddr": "Address",
            "mlocCity": "City",
            "LandVal": "Land Value ($)",
        }
    },
   
    'landValueErieCountyOh': {
        'title': 'Land Value',
        // TODO: Fill out `attrDict` below to define which layer attributes
        //  (keys) should appear in popup when a feature is clicked, and
        //  map each attribute to an informative label (values).
        'attrDict': {
            "PIN": "Parcel Identification Number",
            "MKT_Land_V": "Land Market Value ($)",
            "MKT_Impr_V": "Land Improvement Market Value ($)",
            "MKT_Total_": "Total Market Value ($)",
            "macres": "Total Acres",
            "mlegalDesc": "Legal Description",
            "mlocCity": "City",
            "mlocState": "State",
        }
    },
    
    'landValueLorainCountyOh': {
        'title': 'Land Value',
        // TODO: Fill out `attrDict` below to define which layer attributes
        //  (keys) should appear in popup when a feature is clicked, and
        //  map each attribute to an informative label (values).
        'attrDict': {
            'PIN': "PIN",
            'mailing_ad': "Address",
            'legal_desc': "Legal Description",
            'assessed_b': "Building Appraisal ($)",
            'assessed_t': "Total Appraisal ($)",
            'sale_amoun': "Last Sale Amount ($)",
            'acres': "Acreage",

        }
    },
   
    'landValueLucasCountyOh': {
        'title': 'Land Value',
        // TODO: Fill out `attrDict` below to define which layer attributes
        //  (keys) should appear in popup when a feature is clicked, and
        //  map each attribute to an informative label (values).
        'attrDict': {
            'ASSESSOR_N': "Assessor Number",
            'APRLAND': "Land Appraisal ($)",
            'APRBLDG': "Building Appraisal ($)",
            'APRTOT': "Total Appraisal ($)",
        }
    },

    'landValueRiversideCountyCa': {
        'title': 'Land Value', 'attrDict': {
            "APN": "Assessor Parcel Number",
            "ACREAGE": "Acres",
            "LAND": "Land Value ($)",
            "STRUCTURES": "Structure Value ($)"
        }
    },

    'zoningRiversideCountyCa': {
        'title': 'Zoning',
        'attrDict': {'ZONING': "Zoning Class"}
    },

    'zoningRiversideCityCa': {
        'title': 'Zoning',
        'attrDict': {'ZoneDescri': "Zoning Description"}
    },

    'zoningYorkCountyPa': {
        'title': 'Zoning',
        'attrDict': {'ZNAME': "Zoning Class"}
    },

    'zoningRichmondCountyGa': {
        'title': 'Zoning',
        'attrDict': {'ZONING': "Zoning Class"}
    },

    'zoningLorainCountyOh': {
        'title': 'Zoning',
        'attrDict': {'ZONING_DES': "Zoning Description"}
    },

    'zoningKauaiHi': {
        'title': 'Zoning',
        'attrDict': {
            'descriptio': "Zoning Class"
        }
    },
    
    'zoningFultonCountyOh': {
        'title': 'Zoning',
        'attrDict': {'ZONEDESC': "Zoning Class"}
    },

    'zoningOttawaCountyOh': {
        'title': 'Zoning',
        'attrDict': {'ZONINGDIST': "Zoning Class"}
    },

    'zoningLucasCountyOh': {
        'title': 'Zoning',
        'attrDict': {'ZONING': "Zoning Class"}
    },

    'agLandKauaiHi': {
        'title': 'Agricultural Land',
        'attrDict':
            {
                "Crops_2020": "Agricultural Land Type",
                "Acreage": "Agricultural Land Acres"
            }
    },

    'agLandImportantKauaiHi': {
        'title': 'Important Agricultural Land',
        'attrDict':
            {
                "acres": "Agricultural Land Acres"
            }
    },
    
    'wtrSrvcAreasUs': {
        'title': 'Water Service Area',
        'attrDict': {'PWSID': "Public Water System ID",
                     'PWS_Name': "Public Water System Name",
                     'Population': "Population Served by Public Water System",
                     'System_Type': "System Type",}
    },

    'wtrRatesRiversideCa': {
        'title': 'Water Rates',
        'attrDict': {
            'PWS_Name': 'Public Water System',
            'PWSID': 'Public Water System ID',
            'Population': 'Population Served by Public Water System',
            'Water Rate': 'Water Rate',
        }
    },

    'wtrRatesAugustaGa': {
        'title': 'Water Rates',
        'attrDict':
        {
            "Water Serv": "Water Provider",
            "Water Rate": "Water Rate",
            "Source": "Water Rate Source"
        }
    },

    'wtrRatesKauaiHi': {
        'title': 'Water Rates',
        'attrDict': {
            'PWS_Name': 'Public Water System',
            'PWSID': 'Public Water System ID',
            'Population': 'Population Served by Public Water System',
            'Water Rate': 'Water Rate',
        }
    },

    'wtrRatesYorkCountyPa': {
        'title': 'Water Rates',
        'attrDict':
            {
                "Water Prov": "Water Provider",
                "Water Rate": "Water Rate",
                "Links":"Water Rate Source"
            }
    },

    'wtrRatesWLER': {
        'title': 'Water Rates',
        'attrDict':
            {
                "Water Serv": "Water Provider",
                "PWS_Name": "Public Water System Name",
                "Water Rate": "Water Rate",
            }
    },

    'wastewaterSrvcAreasLucasCountyOh': {
        'title': 'Wastewater Service Area',
        'attrDict': {
            'NAME': "Sewer Service Name",
            'STATUS': "Sewer Service Status",
        }
    },

    'wastewaterSrvcAreasAugustaGa': {
        'title': 'Wastewater Service Area',
        'attrDict': {
            'LABEL': "Sewer Service",
        }
    },

    'elecPrice': {
        'title': 'Electricity Rate',
        'attrDict': {
            'Commericia': 'Commercial Electricity Rate ($/kWh)',
            'Industrial': 'Industrial Electricity Rate ($/kWh)',
            'Utility Na': 'Electric Utility Name',
            'Service Ty':'Power Service Type'
        }
    },

    'natGasPrice': {
        'title': 'Natural Gas Rate',
        'attrDict': {
            'Price of N': 'Average Commercial Price of Natural Gas ($/thousand cubic feet)',
        }
    },

    'outages': {
        'title': 'Outages',
        'attrDict': {
            'Total Numb': 'Customers Affected by Power Outages',
        }
    },

    'popDensity': {
        'title': 'Population Density',
        'attrDict': {'Value': 'Population Density (people/km²)'}
    },

    'income': {
        'title': 'Income',
        'attrDict': {'pc_incom_2':'Average Per Capita Income ($/year)'}
    },

    'ceaWorkers': {
        'title': 'CEA Worker Population',
        'attrDict': {
            'Total Empl': 'Estimated Number of CEA Workers'
        }
    },

    'ceaWages': {
        'title': 'CEA Worker Wages',
        'attrDict': {
            'Average An': 'Average Annual Wage for CEA ($)',
            'Average Ho': 'Average Hourly Wage for CEA ($)',
        }
    },

    'warehouseWorkers': {
        'title': 'Warehouse Worker Population',
        'attrDict': {
            'TOT_EMP': 'Estimated Number of Warehouse Workers'
        }
    },

    'education': {
        'title': 'Education Attainment',
        'attrDict': {
            'Populati_1': 'Population (Less than Highschool Graduate)',
            'Populati_2': 'Population (Highschool Graduate or Higher)',
            'Population': "Population (Bachelor's Degree or Higher)",
        }
    },

    'opportunityZones': {
        'title': 'Opportunity Zone',
        'attrDict': {}
    },


    'unemploy': {
        'title': 'Unemployment Rate',
        'attrDict': {'Unemployme':'Unemployment Rate (%)',}
    },

    'opportunityZonesAugustaGa': {
        'title': 'Opportunity Zone',
        'attrDict': {
            'Zone': 'Opportunity Zone Name',
            'Duration_P': 'Opportunity Zone Duration'
        }
    },
    
    'foodAccess': {
        'title': '',
        'attrDict': {}
    },

    'censusTracts': {
        'title': '',
        'attrDict': {
            'STATE_NAME': 'State'
        }
    },
    'zipcodes': {
        'title': '',
        'attrDict': {
            'ZCTA5CE20': 'Zipcode',
        }
    },

    'counties': {
        'title': '',
        'attrDict': {
            'NAMELSAD': 'County'
        }
    },
}


const INIT_BASELINE_RESULTS = null
// const FAKE_INIT_BASELINE_RESULTS = [
//     [
//         'Energy Consumption (kWh/lb product)',
//         'Water Consumption (gal/lb product)',
//         'Greenhouse Gas Emissions (CO₂e/lb product)',
//         'Cost ($/lb product)'
//     ],
//     [2749, 3111, 1663, 3697]
// ]

const INIT_PATHWAYS_RESULTS = null
// const INIT_PATHWAYS_RESULTS = [
//     [
//         'Pathway',
//         'Energy Consumption (kWh/lb product)',
//         'Water Consumption (gal/lb product)',
//         'Greenhouse Gas Emissions (CO₂e/lb product)',
//         'Cost ($/lb product)'
//     ],
//     [1, "3,209", "1,408", "1,018", "2,158",],
//     [2, "1,018", "2,144", "1,649", "4,355",],
//     [3, "3,777", "1,929", "4,753", "4,699",],
//     [4, "3,344", "2,910", "4,338", "1,263",],
//     [5, "3,340", "2,956", "2,240", "2,456",],
//     [6, "4,217", "1,922", "1,374", "3,742",],
//     [7, "4,066", "2,113", "1,402", "4,858",],
//     [8, "4,796", "3,299", "3,128", "3,561",],
//     [9, "2,436", "4,177", "1,794", "2,753",],
//     [10, "4,824", "4,468", "4,955", "3,765",],
//
// ]
// const FAKE_INIT_PATHWAYS_RESULTS = [
//     [
//         'Pathway',
//         'Energy Consumption (kWh/lb product)',
//         'Water Consumption (gal/lb product)',
//         'Greenhouse Gas Emissions (CO₂e/lb product)',
//         'Cost ($/lb product)'
//     ],
//     [1, "3,209", "1,408", "1,018", "2,158",],
//     [2, "1,018", "2,144", "1,649", "4,355",],
//     [3, "3,777", "1,929", "4,753", "4,699",],
//     [4, "3,344", "2,910", "4,338", "1,263",],
//     [5, "3,340", "2,956", "2,240", "2,456",],
//     [6, "4,217", "1,922", "1,374", "3,742",],
//     [7, "4,066", "2,113", "1,402", "4,858",],
//     [8, "4,796", "3,299", "3,128", "3,561",],
//     [9, "2,436", "4,177", "1,794", "2,753",],
//     [10, "4,824", "4,468", "4,955", "3,765",],
//
// ]

function MapPage() {

    const [loading, setLoading] = useState(true);
    const [show, setShow] = useState(false);
    // const [parcelsVisible, setParcelsVisible] = useState(false);

    const [searchRadFillOpacity, setSearchRadFillOpacity] = useState(
        DEFAULT_SEARCH_RAD_FILL_OPACITY
    );
    const [mapStyle, setMapStyle] = useState("mapbox://styles/mapbox/streets-v9");
    const [layers, setLayers] = useState(INIT_LAYERS)
    const [baselineResults, setBaselineResults] = useState(
        INIT_BASELINE_RESULTS
    )
    const [pathwaysResults, setPathwaysResults] = useState(INIT_PATHWAYS_RESULTS)
    const [sitingModeAccordionExpanded, setSitingModeAccordionExpanded] = useState(false); // New state
    const [facilityFilterExpanded, setFacilityFilterExpanded] = useState(false)
    const [facilityFilterVisible, setFacilityFilterVisible] = useState(false)
    const [baselineResultsVisible, setBaselineResultsVisible] = useState(false)
    const [pathwaysResultsVisible, setPathwaysResultsVisible] = useState(false)
    // const [facilityFilterVisible, setFacilityFilterVisible] = useState(true)
    // const [baselineResultsVisible, setBaselineResultsVisible] = useState(true)
    // const [pathwaysResultsVisible, setPathwaysResultsVisible] = useState(true)
    const [sitingMode, setSitingMode] = useState(false)
    const [allowNewSite, setAllowNewSite] = useState(true)
    const [sitingMarkerLat, setSitingMarkerLat] = useState<number | null>(null)
    const [sitingMarkerLng, setSitingMarkerLng] = useState<number | null>(null)
    const [cursor, setCursor] = useState<string>('grab');
    const [showSitingMarkerPopup, setShowSitingMarkerPopup] = useState(false);
    const [searchRad, setSearchRad] = useState(50);
    const [facilityParams, setFacilityParams] = useState(INIT_FACILITY_PARAMS);
    const [siteClimateZone, setSiteClimateZone] = useState(null);
    const [siteClimateType, setSiteClimateType] = useState(null);
    const [siteClimateMoisture, setSiteClimateMoisture] = useState(null);
    const [siteTemp, setSiteTemp] = useState(null);
    const [siteHeatDegDays, setSiteHeatDegDays] = useState(null);
    const [siteCoolDegDays, setSiteCoolDegDays] = useState(null);
    const [sitePrecip, setSitePrecip] = useState(null);
    const [siteCeaWorkers, setSiteCeaWorkers] = useState(null);
    const [siteMetroNonmetroArea, setSiteMetroNonmetroArea] = useState(null);
    const [siteWarehouseWorkers, setSiteWarehouseWorkers] = useState(null);
    const [siteElecPrice, setSiteElecPrice] = useState(null);
    const [siteProps, setSiteProps] = useState(null);
    const [circleLayerPopupData, setCircleLayerPopupData] = useState(null);
    const [lineLayerPopupData, setLineLayerPopupData] = useState(null);
    const [fillLayerPopupData, setFillLayerPopupData] = useState(null);
    const [fillLayerStackPopupData, setFillLayerStackPopupData] = useState(null);
    const [landfillPopupData, setLandfillPopupData] = useState(null);
    const [compostFacilityPopupData, setCompostFacilityPopupData] = useState(null);
    const [wastewaterTreatPlantPopupData, setWastewaterTreatPlantPopupData] =
        useState(null);
    const [selectedZoningData, setSelectedZoningData] = useState(null)
    const [selectedParcelData, setSelectedParcelData] =
        useState(INIT_SELECTED_PARCEL_DATA);
    const [selectedCensusTractData, setSelectedCensusTractData] = useState(null)
    // useState(INIT_SELECTED_CENSUS_TRACT_DATA);
    const [parcelSelected, setParcelSelected] = useState(false);
    const [parcelPopupOpen, setParcelPopupOpen] = useState(false);
    const [soilSlopePopup, setSoilSlopePopup] = useState(null);
    const [soilSlopeVisible, setSoilSlopeVisible] = useState(true);
    const [soilSlopeOpacity, setSoilSlopeOpacity] = useState(0.8);
    const [landCoverPopup, setLandCoverPopup] = useState(null);
    const [landCoverVisible, setLandCoverVisible] = useState(true);
    const [landCoverOpacity, setLandCoverOpacity] = useState(0.8);
    const [cropsPopup, setCropsPopup] = useState(null);
    const [cropsVisible, setCropsVisible] = useState(true);
    const [cropsOpacity, setCropsOpacity] = useState(0.8);

    const mapRef = useRef<MapRef | null>(null);

    const mapRefCallback = useCallback((ref: MapRef | null) => {
        if (ref !== null) {
            //Set the actual ref we use elsewhere
            mapRef.current = ref;
            const map = ref;

            const loadImage = () => {
                if (!map.hasImage("shop-cart-icon")) {
                    //NOTE This is really how are you load an SVG for mapbox
                    let img = new Image(24, 24);
                    img.crossOrigin = "Anonymous"; //it's not cross origin, but this quiets the canvas error
                    img.onload = () => {
                        map.addImage("shop-cart-icon", img, {sdf: true});
                    };
                    img.src = MdLocalGroceryStore

                    //NOTE ref for adding local image instead
                    // map.loadImage("./static/img/shop-15.png", (error, image) => {
                    //   if (error || image === undefined) throw error;
                    //   map.addImage("store-icon", image, { sdf: true });
                    // });
                }
                if (!map.hasImage("warehouse-icon")) {
                    //NOTE This is really how to load an SVG for mapbox
                    let img = new Image(24, 24);
                    img.crossOrigin = "Anonymous"; //it's not cross origin, but this quiets the canvas error
                    img.onload = () => {
                        map.addImage("warehouse-icon", img, {sdf: true});
                    };
                    img.src = Warehouse
                }
                if (!map.hasImage("shop-basket-icon")) {
                    //NOTE This is really how are you load an SVG for mapbox
                    let img = new Image(24, 24);
                    img.crossOrigin = "Anonymous"; //it's not cross origin, but this quiets the canvas error
                    img.onload = () => {
                        map.addImage("shop-basket-icon", img, {sdf: true});
                    };
                    img.src = FaBasketShopping


                }
                if (!map.hasImage("fruits-pear-icon")) {
                    //NOTE This is really how are you load an SVG for mapbox
                    let img = new Image(24, 24);
                    img.crossOrigin = "Anonymous"; //it's not cross origin, but this quiets the canvas error
                    img.onload = () => {
                        map.addImage("fruits-pear-icon", img, {sdf: true});
                    };
                    img.src = FruitsPear;

                }
                if (!map.hasImage("store-icon")) {
                    //NOTE This is really how are you load an SVG for mapbox
                    let img = new Image(24, 24);
                    img.crossOrigin = "Anonymous"; //it's not cross origin, but this quiets the canvas error
                    img.onload = () => {
                        map.addImage("store-icon", img, {sdf: true});
                    };
                    img.src = IoStorefrontSharp;
                }
            };

            loadImage();

            //TODO need this?
            map.on("styleimagemissing", (e) => {
                const id = e.id; // id of the missing image
                loadImage();
            });
        }
    }, []);


    const numFillLayersVisible = () => {
        var n = 0
        var visible = false
        for (let i = 0; i < layers.length; i++) {
            const layer = layers[i]
            const layerType = layer['type']
            const isFillLayer = layerType === 'fill';
            var opacityProp = `${layerType}-opacity`
            if (layerType === 'symbol') {
                opacityProp = 'icon-opacity'
            }
            visible = layer.paint[opacityProp] != 0
            if (visible && isFillLayer) {
                n += 1
            }
        }
        return n
    }
    const layerVisible = (layerId: string): boolean => {
        const targetLayer = layers.find(x => x.id == layerId)
        var visible = false
        if (targetLayer) {
            const layerType = targetLayer['type'];
            var opacityProp = `${layerType}-opacity`
            if (layerType === 'symbol') {
                opacityProp = 'icon-opacity'
            }
            visible = targetLayer.paint[opacityProp] != 0
        }
        return visible
    }


    // Declare map layers that depend on state variables.
    var selectedParcelRiversideCountyCaLayer: FillLayer = {
        id: 'selectedParcelRiversideCountyCaLayer',
        type: 'fill',
        source: 'mapbox://ceascreeningtooldev.5xhocvwg',
        'source-layer': 'parcels_riverside_ca_prod',
        'layout': {
            // Make the layer visible by default.
            'visibility': 'visible'
        },
        "paint": {
            "fill-outline-color": "rgb(206,181,20)",
            "fill-opacity": 0.6,
            // "fill-color": '#ceb514'
            "fill-color": "#ceb514"
        },
        filter: ['==', 'PIN', selectedParcelData.parcelId]
    };
    var selectedParcelBorderRiversideCountyCaLayer: LineLayer = {
        id: 'selectedParcelBorderRiversideCountyCa',
        type: 'line',
        source: 'mapbox://ceascreeningtooldev.5xhocvwg',
        'source-layer': 'parcels_riverside_ca_prod',
        'layout': {
            // Make the layer visible by default.
            'visibility': 'visible'
        },
        "paint": {
            "line-color": "rgb(231,5,27)",
            "line-opacity": 0.9,
            "line-width": 3,
        },
        filter: ['==', 'PIN', selectedParcelData.parcelId]
    };

    var selectedParcelYorkCountyPaLayer: FillLayer = {
        id: 'selectedParcelYorkCountyPaLayer',
        type: 'fill',
        source: 'mapbox://ceascreeningtooldev.1oac1z5s',
        'source-layer': 'york_county_pa_parcels',
        'layout': {
            // Make the layer visible by default.
            'visibility': 'visible'
        },
        "paint": {
            "fill-outline-color": "rgb(206,181,20)",
            "fill-opacity": 0.6,
            // "fill-color": '#ceb514'
            "fill-color": "#ceb514"
        },
        filter: ['==', 'OBJECTID', selectedParcelData.parcelId]
    };
    var selectedParcelBorderYorkCountyPaLayer: LineLayer = {
        id: 'selectedParcelBorderYorkCountyPa',
        type: 'line',
        source: 'mapbox://ceascreeningtooldev.1oac1z5s',
        'source-layer': 'york_county_pa_parcels',
        'layout': {
            // Make the layer visible by default.
            'visibility': 'visible'
        },
        "paint": {
            "line-color": "rgb(231,5,27)",
            "line-opacity": 0.9,
            "line-width": 3,
        },
        filter: ['==', 'OBJECTID', selectedParcelData.parcelId]
    };
    var selectedParcelLorainCountyOhLayer: FillLayer = {
        id: 'selectedParcelLorainCountyOhLayer',
        type: 'fill',
        source: landValueLorainCountyOhLayer.source,
        'source-layer': landValueLorainCountyOhLayer['source-layer'],
        'layout': {
            // Make the layer visible by default.
            'visibility': 'visible'
        },
        "paint": {
            "fill-outline-color": "rgb(206,181,20)",
            "fill-opacity": 0.6,
            // "fill-color": '#ceb514'
            "fill-color": "#ceb514"
        },
        filter: [
            '==',
            landValueLorainCountyOhLayer.metadata.uidField,
            selectedParcelData.parcelId
        ]
    };
    var selectedParcelBorderLorainCountyOhLayer: LineLayer = {
        id: 'selectedParcelBorderLorainCountyOh',
        type: 'line',
        source: landValueLorainCountyOhLayer.source,
        'source-layer': landValueLorainCountyOhLayer['source-layer'],
        'layout': {
            // Make the layer visible by default.
            'visibility': 'visible'
        },
        "paint": {
            "line-color": "rgb(231,5,27)",
            "line-opacity": 0.9,
            "line-width": 3,
        },
        filter: [
            '==',
            landValueLorainCountyOhLayer.metadata.uidField,
            selectedParcelData.parcelId
        ]
    };
    var selectedParcelMonroeCountyMiLayer: FillLayer = {
        id: 'selectedParcelMonroeCountyMiLayer',
        type: 'fill',
        source: landValueMonroeCountyMiLayer.source,
        'source-layer': landValueMonroeCountyMiLayer['source-layer'],
        'layout': {
            // Make the layer visible by default.
            'visibility': 'visible'
        },
        "paint": {
            "fill-outline-color": "rgb(206,181,20)",
            "fill-opacity": 0.6,
            // "fill-color": '#ceb514'
            "fill-color": "#ceb514"
        },
        filter: [
            '==',
            landValueMonroeCountyMiLayer.metadata.uidField,
            selectedParcelData.parcelId
        ]
    };
    var selectedParcelBorderMonroeCountyMiLayer: LineLayer = {
        id: 'selectedParcelBorderMonroeCountyMi',
        type: 'line',
        source: landValueMonroeCountyMiLayer.source,
        'source-layer': landValueMonroeCountyMiLayer['source-layer'],
        'layout': {
            // Make the layer visible by default.
            'visibility': 'visible'
        },
        "paint": {
            "line-color": "rgb(231,5,27)",
            "line-opacity": 0.9,
            "line-width": 3,
        },
        filter: [
            '==',
            landValueMonroeCountyMiLayer.metadata.uidField,
            selectedParcelData.parcelId
        ]
    };


    var selectedParcelErieCountyOhLayer: FillLayer = {
        id: 'selectedParcelErieCountyOhLayer',
        type: 'fill',
        source: landValueErieCountyOhLayer.source,
        'source-layer': landValueErieCountyOhLayer['source-layer'],
        'layout': {
            // Make the layer visible by default.
            'visibility': 'visible'
        },
        "paint": {
            "fill-outline-color": "rgb(206,181,20)",
            "fill-opacity": 0.6,
            // "fill-color": '#ceb514'
            "fill-color": "#ceb514"
        },
        filter: [
            '==',
            landValueErieCountyOhLayer.metadata.uidField,
            selectedParcelData.parcelId
        ]
    };
    var selectedParcelBorderErieCountyOhLayer: LineLayer = {
        id: 'selectedParcelBorderErieCountyOh',
        type: 'line',
        source: landValueErieCountyOhLayer.source,
        'source-layer': landValueErieCountyOhLayer['source-layer'],
        'layout': {
            // Make the layer visible by default.
            'visibility': 'visible'
        },
        "paint": {
            "line-color": "rgb(231,5,27)",
            "line-opacity": 0.9,
            "line-width": 3,
        },
        filter: [
            '==',
            landValueErieCountyOhLayer.metadata.uidField,
            selectedParcelData.parcelId
        ]
    };
    var selectedParcelWayneCountyOhLayer: FillLayer = {
        id: 'selectedParcelWayneCountyOhLayer',
        type: 'fill',
        source: landUseWayneCountyOhLayer.source,
        'source-layer': landUseWayneCountyOhLayer['source-layer'],
        'layout': {
            // Make the layer visible by default.
            'visibility': 'visible'
        },
        "paint": {
            "fill-outline-color": "rgb(206,181,20)",
            "fill-opacity": 0.6,
            // "fill-color": '#ceb514'
            "fill-color": "#ceb514"
        },
        filter: [
            '==',
            landUseWayneCountyOhLayer.metadata.uidField,
            selectedParcelData.parcelId
        ]
    };
    var selectedParcelBorderWayneCountyOhLayer: LineLayer = {
        id: 'selectedParcelBorderWayneCountyOh',
        type: 'line',
        source: landUseWayneCountyOhLayer.source,
        'source-layer': landUseWayneCountyOhLayer['source-layer'],
        'layout': {
            // Make the layer visible by default.
            'visibility': 'visible'
        },
        "paint": {
            "line-color": "rgb(231,5,27)",
            "line-opacity": 0.9,
            "line-width": 3,
        },
        filter: [
            '==',
            landUseWayneCountyOhLayer.metadata.uidField,
            selectedParcelData.parcelId
        ]
    };
    var selectedParcelWayneCountyMiLayer: FillLayer = {
        id: 'selectedParcelWayneCountyMiLayer',
        type: 'fill',
        source: landUseWayneCountyMiLayer.source,
        'source-layer': landUseWayneCountyMiLayer['source-layer'],
        'layout': {
            // Make the layer visible by default.
            'visibility': 'visible'
        },
        "paint": {
            "fill-outline-color": "rgb(206,181,20)",
            "fill-opacity": 0.6,
            // "fill-color": '#ceb514'
            "fill-color": "#ceb514"
        },
        filter: [
            '==',
            landUseWayneCountyMiLayer.metadata.uidField,
            selectedParcelData.parcelId
        ]
    };
    var selectedParcelBorderWayneCountyMiLayer: LineLayer = {
        id: 'selectedParcelBorderWayneCountyMi',
        type: 'line',
        source: landUseWayneCountyMiLayer.source,
        'source-layer': landUseWayneCountyMiLayer['source-layer'],
        'layout': {
            // Make the layer visible by default.
            'visibility': 'visible'
        },
        "paint": {
            "line-color": "rgb(231,5,27)",
            "line-opacity": 0.9,
            "line-width": 3,
        },
        filter: [
            '==',
            landUseWayneCountyMiLayer.metadata.uidField,
            selectedParcelData.parcelId
        ]
    };
    var selectedParcelOttawaCountyOhLayer: FillLayer = {
        id: 'selectedParcelOttawaCountyOhLayer',
        type: 'fill',
        source: landUseOttawaCountyOhLayer.source,
        'source-layer': landUseOttawaCountyOhLayer['source-layer'],
        'layout': {
            // Make the layer visible by default.
            'visibility': 'visible'
        },
        "paint": {
            "fill-outline-color": "rgb(206,181,20)",
            "fill-opacity": 0.6,
            // "fill-color": '#ceb514'
            "fill-color": "#ceb514"
        },
        filter: [
            '==',
            landUseOttawaCountyOhLayer.metadata.uidField,
            selectedParcelData.parcelId
        ]
    };
    var selectedParcelBorderOttawaCountyOhLayer: LineLayer = {
        id: 'selectedParcelBorderOttawaCountyOh',
        type: 'line',
        source: landUseOttawaCountyOhLayer.source,
        'source-layer': landUseOttawaCountyOhLayer['source-layer'],
        'layout': {
            // Make the layer visible by default.
            'visibility': 'visible'
        },
        "paint": {
            "line-color": "rgb(231,5,27)",
            "line-opacity": 0.9,
            "line-width": 3,
        },
        filter: [
            '==',
            landUseOttawaCountyOhLayer.metadata.uidField,
            selectedParcelData.parcelId
        ]
    };

    var selectedParcelLucasCountyOhLayer: FillLayer = {
        id: 'selectedParcelLucasCountyOhLayer',
        type: 'fill',
        source: landValueLucasCountyOhLayer.source,
        'source-layer': landValueLucasCountyOhLayer['source-layer'],
        'layout': {
            // Make the layer visible by default.
            'visibility': 'visible'
        },
        "paint": {
            "fill-outline-color": "rgb(206,181,20)",
            "fill-opacity": 0.6,
            // "fill-color": '#ceb514'
            "fill-color": "#ceb514"
        },
        filter: [
            '==',
            landValueLucasCountyOhLayer.metadata.uidField,
            selectedParcelData.parcelId
        ]
    };
    var selectedParcelBorderLucasCountyOhLayer: LineLayer = {
        id: 'selectedParcelBorderLucasCountyOh',
        type: 'line',
        source: landValueLucasCountyOhLayer.source,
        'source-layer': landValueLucasCountyOhLayer['source-layer'],
        'layout': {
            // Make the layer visible by default.
            'visibility': 'visible'
        },
        "paint": {
            "line-color": "rgb(231,5,27)",
            "line-opacity": 0.9,
            "line-width": 3,
        },
        filter: [
            '==',
            landValueLucasCountyOhLayer.metadata.uidField,
            selectedParcelData.parcelId
        ]
    };

    var selectedParcelKauaiCountyHiLayer: FillLayer = {
        id: 'selectedParcelKauaiCountyHiLayer',
        type: 'fill',
        source: landUseKauaiCountyHiLayer.source,
        'source-layer': landUseKauaiCountyHiLayer['source-layer'],
        'layout': {
            // Make the layer visible by default.
            'visibility': 'visible'
        },
        "paint": {
            "fill-outline-color": "rgb(206,181,20)",
            "fill-opacity": 0.6,
            // "fill-color": '#ceb514'
            "fill-color": "#ceb514"
        },
        filter: ['==', 'objectid', selectedParcelData.parcelId]
    };
    var selectedParcelBorderKauaiCountyHiLayer: LineLayer = {
        id: 'selectedParcelBorderKauaiCountyHi',
        type: 'line',
        source: landUseKauaiCountyHiLayer.source,
        'source-layer': landUseKauaiCountyHiLayer['source-layer'],
        'layout': {
            // Make the layer visible by default.
            'visibility': 'visible'
        },
        "paint": {
            "line-color": "rgb(231,5,27)",
            "line-opacity": 0.9,
            "line-width": 3,
        },
        filter: ['==', 'objectid', selectedParcelData.parcelId]
    };

    var selectedParcelRichmondCountyGaLayer: FillLayer = {
        id: 'selectedParcelRichmondCountyGaLayer',
        type: 'fill',
        source: 'mapbox://ceascreeningtooldev.parcels_augusta_ga',
        'source-layer': 'parcels_augusta_ga',
        'layout': {
            // Make the layer visible by default.
            'visibility': 'visible'
        },
        "paint": {
            "fill-outline-color": "rgb(206,181,20)",
            "fill-opacity": 0.6,
            // "fill-color": '#ceb514'
            "fill-color": "#ceb514"
        },
        filter: ['==', 'OBJECTID', selectedParcelData.parcelId]
    };
    var selectedParcelBorderRichmondCountyGaLayer: LineLayer = {
        id: 'selectedParcelBorderRichmondCountyGa',
        type: 'line',
        source: 'mapbox://ceascreeningtooldev.parcels_augusta_ga',
        'source-layer': 'parcels_augusta_ga',
        'layout': {
            // Make the layer visible by default.
            'visibility': 'visible'
        },
        "paint": {
            "line-color": "rgb(231,5,27)",
            "line-opacity": 0.9,
            "line-width": 3,
        },
        filter: ['==', 'OBJECTID', selectedParcelData.parcelId]
    };


    const onMouseLeave = useCallback(() => setCursor('auto'), []);
    const onMouseMove = (evt) => {
        const layersUnderMouse = evt.features.map((x) => x.layer.id)
        const clickableLayersUnderMouse =
            clickableLayerIds.filter(x => layersUnderMouse.includes(x))
        // Handle mouseMove events when siting mode is OFF:
        if (!sitingMode) {
            setCursor('grab')
            clickableLayersUnderMouse.forEach((layerId) => {
                    const layer = layers.find(x => x.id == layerId)
                    const layerType = layer['type'];
                    var opacityProp = `${layerType}-opacity`
                    if (layerType === 'symbol') {
                        opacityProp = 'icon-opacity'
                    }
                    const visible = layer.paint[opacityProp] != 0
                    if (clickableLayerIds.includes(layer.id) && visible) {
                        setCursor('pointer')
                    }
                }
            )
            // Handle mouseMove events when siting mode is ON:
        } else {
            if (sitingMode && allowNewSite) {
                setCursor('crosshair')
            } else if (clickableLayersUnderMouse.length > 0) {
                clickableLayersUnderMouse.forEach((layerId) => {
                        const layer = layers.find(x => x.id == layerId)
                        const layerType = layer['type'];
                        var opacityProp = `${layerType}-opacity`
                        if (layerType === 'symbol') {
                            opacityProp = 'icon-opacity'
                        }
                        const visible = layer.paint[opacityProp] != 0
                        if (clickableLayerIds.includes(layer.id) && visible) {
                            setCursor('pointer')
                        }
                    }
                )
            } else {
                setCursor('grab')
            }
        }
    }

    const [activeFacilityCollapses, setActiveFacilityCollapses] = useState(
        INIT_ACTIVE_FACILITY_COLLAPSES
    )
    const [activeLayerCollapses, setActiveLayerCollapses] = useState(
        INIT_ACTIVE_LAYER_COLLAPSES
    )

    const searchRadOpts = { // Removed turf.CircleOptions type annotation
        steps: 100,
        units: "kilometers" as turf.Units,
        properties: {key: "value"}
    };

    const sitingMarkerLngLat = [sitingMarkerLng, sitingMarkerLat] as [number, number];
    const searchRadCirc = turf.circle(
        sitingMarkerLngLat, searchRad, searchRadOpts
    );
    const searchRadLine = turf.lineString(
        searchRadCirc.geometry.coordinates[0] // Use the first coordinate ring
    );

    const handleClose = () => setShow(false);
    const handleFeedbackBtnClick = () => setShow(true);

    const handleMapOnLoad = (evt) => {
        setLoading(false)
    }

    const mapOnDragStart = (evt) => {
        setCursor('grabbing')
    }
    const mapOnDragEnd = (evt) => {
        sitingMode && allowNewSite ? setCursor('crosshair') : setCursor('grab')
    }
    // const getFoodAccessPopupData = (evt, feature) => {
    //     const layer = feature.layer
    //     const geoIdCol = layer.id === 'opportunityZones' ? 'GEOID10' : 'GEOID'
    //     const attrDict = {}
    //     // const featProps = structuredClone(feature.properties)
    //     const featProps = {}
    //     const foodAccess = foodAccessDataDict[
    //         foodAccessData[feature.properties[geoIdCol]]
    //         ] ? foodAccessDataDict[
    //         foodAccessData[feature.properties[geoIdCol]]
    //         ] : 'None'
    //     const joinProps = {
    //         "<a href='https://gisportal.ers.usda.gov/portal/apps/experiencebuilder/experience/?id=a53ebd7396cd4ac3a3ed09137676fd40&page=Measuring-Access' target='_blank'>USDA ERS Food Access Indicators</a>": foodAccess,
    //     }
    //     Object.keys(joinProps).forEach((k) => {
    //         attrDict[k] = k
    //         featProps[k] = joinProps[k]
    //     })
    //     return {'attrDict': attrDict, 'properties': featProps}
    // }
    // const getOppZonePopupData = (evt, feature) => {
    //     const layer = feature.layer
    //     const attrDict = {}
    //     // const featProps = structuredClone(feature.properties)
    //     const featProps = {}
    //     const oppZone = layer.id === 'opportunityZones' ? 'Yes' : 'No'
    //     const joinProps = {
    //         "<a href='https://www.irs.gov/credits-deductions/businesses/opportunity-zones' target='_blank'>Opportunity Zone</a>": oppZone
    //     }
    //     Object.keys(joinProps).forEach((k) => {
    //         attrDict[k] = k
    //         featProps[k] = joinProps[k]
    //     })
    //     return {'attrDict': attrDict, 'properties': featProps}
    // }

    // const getCeaWorkersPopupData = (evt, feature) => {
    //     const layer = feature.layer
    //     const attrDict = {}
    //     const featProps = structuredClone(feature.properties)
    //     const ceaWorkers = numWithCommas(featProps['TOT_EMP'])
    //     const area = featProps['AREA_TITLE']
    //     const joinProps = {
    //         "<a href='https://www.bls.gov/oes/current/msa_def.htm' target='_blank'>Metropolitan/Nonmetropolitan Area</a>": area,
    //         "<a href='https://www.bls.gov/oes/tables.htm' target='_blank'>Estimated Number of CEA Workers in Metro/Nonmetro Area</a>": ceaWorkers,
    //     }
    //     Object.keys(joinProps).forEach((k) => {
    //         attrDict[k] = k
    //         featProps[k] = joinProps[k]
    //     })
    //     return {'attrDict': attrDict, 'properties': featProps}
    // }
    // const getWarehouseWorkersPopupData = (evt, feature) => {
    //     const layer = feature.layer
    //     const attrDict = {}
    //     const featProps = structuredClone(feature.properties)
    //     const warehouseWorkers = numWithCommas(featProps['TOT_EMP'])
    //     const area = featProps['AREA_TITLE']
    //     const joinProps = {
    //         "<a href='https://www.bls.gov/oes/current/msa_def.htm' target='_blank'>Metropolitan/Nonmetropolitan Area</a>": area,
    //         "<a href='https://www.bls.gov/oes/tables.htm' target='_blank'>Estimated Number of Warehouse Workers in Metro/Nonmetro Area</a>": warehouseWorkers,
    //     }
    //     Object.keys(joinProps).forEach((k) => {
    //         attrDict[k] = k
    //         featProps[k] = joinProps[k]
    //     })
    //     return {'attrDict': attrDict, 'properties': featProps}
    // }

    // const getPrecipPopupData = (evt, feature) => {
    //     const attrDict = {}
    //     const featProps = structuredClone(feature.properties)
    //     // const featProps = {}
    //     const precip = Math.round(precipData[featProps.GEOID])

    //     const joinProps = {
    //         "Annual Precipitation (5-year mean) (inches)": `${precip} `
    //     }
    //     Object.keys(joinProps).forEach((k) => {
    //         attrDict[k] = k
    //         featProps[k] = joinProps[k]
    //     })
    //     return {'attrDict': attrDict, 'properties': featProps}
    // }

    // const getCoolDegDaysPopupData = (evt, feature) => {
    //     const attrDict = {}
    //     const featProps = structuredClone(feature.properties)
    //     // const featProps = {}
    //     const cdd = Math.round(coolDegDaysData[featProps.GEOID])

    //     const joinProps = {
    //         "Annual Cooling Degree Days (5-year mean) (°F)":
    //             `${numWithCommas(cdd)} `,
    //     }
    //     Object.keys(joinProps).forEach((k) => {
    //         attrDict[k] = k
    //         featProps[k] = joinProps[k]
    //     })
    //     return {'attrDict': attrDict, 'properties': featProps}
    // }
    // const getHeatDegDaysPopupData = (evt, feature) => {
    //     const attrDict = {}
    //     const featProps = structuredClone(feature.properties)
    //     // const featProps = {}
    //     const hdd = Math.round(heatDegDaysData[featProps.GEOID])

    //     const joinProps = {
    //         "Annual Heating Degree Days (5-year mean) (°F)":
    //             `${numWithCommas(hdd)} `,
    //     }
    //     Object.keys(joinProps).forEach((k) => {
    //         attrDict[k] = k
    //         featProps[k] = joinProps[k]
    //     })
    //     return {'attrDict': attrDict, 'properties': featProps}
    // }
    // const getTemperaturePopupData = (evt, feature) => {
    //     const attrDict = {}
    //     const featProps = structuredClone(feature.properties)
    //     // const featProps = {}
    //     const temperature = Math.round(tempData[featProps.GEOID])

    //     const joinProps = {
    //         "Temperature (5-year mean) (°F)": `${temperature}`,
    //     }
    //     Object.keys(joinProps).forEach((k) => {
    //         attrDict[k] = k
    //         featProps[k] = joinProps[k]
    //     })
    //     return {'attrDict': attrDict, 'properties': featProps}
    // }
    // const getIncomePopupData = (evt, feature) => {
    //     const attrDict = {}
    //     const featProps = structuredClone(feature.properties)
    //     // const featProps = {}
    //     const income = numWithCommasUSD(parseInt(incomeData[featProps.GEOID]), 0)

    //     const joinProps = {
    //         "<a href='https://www.bea.gov/data/income-saving/personal-income-county-metro-and-other-areas' target='_blank'>Per Capita Personal Income</a>": income,
    //     }
    //     Object.keys(joinProps).forEach((k) => {
    //         attrDict[k] = k
    //         featProps[k] = joinProps[k]
    //     })
    //     return {'attrDict': attrDict, 'properties': featProps}
    // }
    // const getUnemployPopupData = (evt, feature) => {
    //     const attrDict = {}
    //     const featProps = structuredClone(feature.properties)
    //     // const featProps = {}
    //     const unemploy = unemployData[featProps.GEOID].toFixed(1)

    //     const joinProps = {
    //         "<a href='https://www.bls.gov/lau/tables.htm' target='_blank'>Unemployment Rate</a>": `${unemploy}%`,
    //     }
    //     Object.keys(joinProps).forEach((k) => {
    //         attrDict[k] = k
    //         featProps[k] = joinProps[k]
    //     })
    //     return {'attrDict': attrDict, 'properties': featProps}
    // }

    // const getEdPopupData = (evt, feature) => {
    //     const attrDict = {}
    //     const featProps = structuredClone(feature.properties)
    //     // const featProps = {}
    //     var edPopLessThanHs
    //     if (Object.keys(edPopLessThanHsData).includes(featProps.GEOID)) {
    //         edPopLessThanHs = edPopLessThanHsData[featProps.GEOID]
    //         if (hasLetters(edPopLessThanHs)) {
    //             edPopLessThanHs = 'Data Unavailable'
    //         } else {
    //             edPopLessThanHs = numWithCommas(edPopLessThanHs.toFixed(1))
    //         }
    //     } else {
    //         edPopLessThanHs = 'Data Unavailable'
    //     }
    //     var edPopHsOrHigher
    //     if (Object.keys(edPopHsOrHigherData).includes(featProps.GEOID)) {
    //         edPopHsOrHigher = edPopHsOrHigherData[featProps.GEOID]
    //         if (hasLetters(edPopHsOrHigher)) {
    //             edPopHsOrHigher = 'Data Unavailable'
    //         } else {
    //             edPopHsOrHigher = numWithCommas(edPopHsOrHigher.toFixed(1))
    //         }
    //     } else {
    //         edPopHsOrHigher = 'Data Unavailable'
    //     }

    //     var edPopBachelorsOrHigher
    //     if (Object.keys(edPopBachelorsOrHigherData).includes(featProps.GEOID)) {
    //         edPopBachelorsOrHigher = edPopBachelorsOrHigherData[featProps.GEOID]
    //         if (hasLetters(edPopBachelorsOrHigher)) {
    //             edPopBachelorsOrHigher = 'Data Unavailable'
    //         } else {
    //             edPopBachelorsOrHigher = numWithCommas(edPopBachelorsOrHigher.toFixed(1))
    //         }
    //     } else {
    //         edPopBachelorsOrHigher = 'Data Unavailable'
    //     }

    //     const joinProps = {
    //         "<a href='https://www.census.gov/topics/education.html' target='_blank'>Population with less than High School Diploma</a>":
    //             `${edPopLessThanHs}`,
    //         "<a href='https://www.census.gov/topics/education.html' target='_blank'>Population with High School Diploma or Higher</a>":
    //             `${edPopHsOrHigher}`,
    //         "<a href='https://www.census.gov/topics/education.html' target='_blank'>Population with Bachelor's Degree or Higher</a>":
    //             `${edPopBachelorsOrHigher}`,
    //     }
    //     Object.keys(joinProps).forEach((k) => {
    //         attrDict[k] = k
    //         featProps[k] = joinProps[k]
    //     })
    //     return {'attrDict': attrDict, 'properties': featProps}
    // }

    // const getAirQualPopupData = (evt, feature) => {
    //     const attrDict = {}
    //     const featProps = structuredClone(feature.properties)
    //     // const featProps = {}
    //     var aq
    //     if (Object.keys(airQualData).includes(featProps.GEOID)) {
    //         aq = airQualData[featProps.GEOID]
            
    //     } else {
    //         aq = 'Data Unavailable'
    //     }
    //     if (aq == 'Data Unavailable' && HIDE_UNAVAILABLE_DATA_IN_POPUPS) {
    //         return {'attrDict': attrDict, 'properties': featProps}
    //     }
    //     const joinProps = {
    //         "<a href='https://www3.epa.gov/airquality/greenbook/anayo_ak.html' target='_blank'>Non-attainment Zone</a>":
    //             `${aq}`,
    //     }
    //     Object.keys(joinProps).forEach((k) => {
    //         attrDict[k] = k
    //         featProps[k] = joinProps[k]
    //     })
    //     return {'attrDict': attrDict, 'properties': featProps}
    // }
    // const getPopDensityPopupData = (evt, feature) => {
    //     const layer = feature.layer
    //     const attrDict = {}
    //     const featProps = structuredClone(feature.properties)
    //     // const featProps = {}
    //     const popDensity = numWithCommas(popDensityData[featProps.GEOID], 1)

    //     const joinProps = {
    //         "Population Density (people/km²)": `${popDensity}`,
    //     }
    //     Object.keys(joinProps).forEach((k) => {
    //         attrDict[k] = k
    //         featProps[k] = joinProps[k]
    //     })
    //     return {'attrDict': attrDict, 'properties': featProps}
    // }
    const handleFillLayerFeatureStackClick = (evt) => {
        const layerIdsUnderClick = evt.features.map((f) => f.layer.id);
    
        // Check if the clicked layer is 'wtrRatesAugustaGa' and is visible
        const wtrRatesLayer = layers.find((layer) => layer.id === 'wtrRatesAugustaGa');
        const wtrRatesVisible = wtrRatesLayer && wtrRatesLayer.paint['fill-opacity'] !== 0;
    
        if (layerIdsUnderClick.includes('wtrRatesAugustaGa') && wtrRatesVisible) {
            const feature = evt.features.find((f) => f.layer.id === 'wtrRatesAugustaGa');
            const attrDict = layerPopups['wtrRatesAugustaGa'].attrDict;
            const properties = Object.keys(feature.properties)
                .filter((key) => Object.keys(attrDict).includes(key))
                .reduce((obj, key) => {
                    obj[key] = feature.properties[key];
                    return obj;
                }, {});
    
            // Set the pop-up data for Augusta's water rates
            setFillLayerPopupData({
                latitude: evt.lngLat.lat,
                longitude: evt.lngLat.lng,
                title: layerPopups['wtrRatesAugustaGa'].title,
                attrDict: attrDict,
                properties: properties,
            });
    
            return; // Exit early to prevent combining with other layers
        }
    
        // Existing logic for handling other layers
        var attrDicts = [];
        var propertyDicts = [];
        for (let i = 0; i < evt.features.length; i++) {
            const feature = evt.features[i];
            const layer = feature.layer;
            const layerType = layer['type'];
            var opacityProp = `${layerType}-opacity`;
            if (layerType === 'symbol') {
                opacityProp = 'icon-opacity';
            }
            const visible = layer.paint[opacityProp] != 0;
    
            if (visible && layerType === 'fill' && layer.id !== 'wtrRatesAugustaGa') {
                const attrDict = layerPopups[layer.id]?.attrDict || {};
                const properties = Object.keys(feature.properties)
                    .filter((key) => Object.keys(attrDict).includes(key))
                    .reduce((obj, key) => {
                        obj[key] = feature.properties[key];
                        return obj;
                    }, {});
    
                attrDicts.push(attrDict);
                propertyDicts.push(properties);
            }
        }
    
        // Combine data from other layers into a single pop-up
        const properties = Object.assign({}, ...propertyDicts);
        const combinedAttrDict = Object.assign({}, ...attrDicts);
        setFillLayerStackPopupData({
            latitude: evt.lngLat.lat,
            longitude: evt.lngLat.lng,
            title: 'Location Profile',
            attrDict: combinedAttrDict,
            properties: properties,
        });
    };
    const handleFeatureClick = (evt, feature) => {
        const layer = feature.layer
        const layerType = layer['type'];
        var opacityProp = `${layerType}-opacity`
        if (layerType === 'symbol') {
            opacityProp = 'icon-opacity'
        }
        const visible = layer.paint[opacityProp] != 0
        if (visible && clickableLayerIds.includes(layer.id)) {
            // if (countyFillLayerIds.includes(feature.layer.id)) {
            //     handleCountyClick(evt, feature)
            // } else if (censusTractFillLayerIds.includes(feature.layer.id)) {
            //     handleCensusTractClick(evt, feature)
            // } else if (zipcodeFillLayerIds.includes(feature.layer.id)) {
            //     console.log('zipcode clicked')
            // } else if (feature.layer.id == 'parcelsYorkCountyPa') {

            // TODO @tyler: generalize these parcel cases
            if (layer.id === 'wtrRatesAugustaGa') {
                const attrDict = layerPopups[layer.id].attrDict;
                const properties = feature.properties;
    
                // Handle multiple values for each attribute
                const processedProperties = Object.keys(attrDict).reduce((acc, key) => {
                    const value = properties[key];
                    acc[key] = Array.isArray(value) ? value.join(', ') : value;
                    return acc;
                }, {});
    
                setFillLayerPopupData({
                    latitude: evt.lngLat.lat,
                    longitude: evt.lngLat.lng,
                    title: layerPopups[layer.id].title,
                    attrDict: attrDict,
                    properties: processedProperties,
                });
            
            } else if (feature.layer.id == 'landValueYorkCountyPa') {
                // Handle click on a parcel that is already selected.
                if (parcelSelected &&
                    feature.properties.OBJECTID == selectedParcelData.parcelId
                ) {
                    setParcelSelected(false)
                } else {
                    setSelectedParcelData(
                        Object.assign({
                            'latitude': evt.lngLat.lat,
                            'longitude': evt.lngLat.lng,
                            'parcelId': feature.properties.OBJECTID,
                            'attrDict': layerPopups[feature.layer.id].attrDict,
                        }, feature)
                    )
                    setParcelSelected(true)
                    setParcelPopupOpen(true)
                }
            } else if (feature.layer.id == 'landUseKauaiCountyHi') {
                // Handle click on a parcel that is already selected.
                if (parcelSelected &&
                    feature.properties.objectid == selectedParcelData.parcelId
                ) {
                    setParcelSelected(false)
                } else {
                    setSelectedParcelData(
                        Object.assign({
                            'latitude': evt.lngLat.lat,
                            'longitude': evt.lngLat.lng,
                            'parcelId': feature.properties.objectid,
                            'attrDict': layerPopups[feature.layer.id].attrDict,
                        }, feature)
                    )
                    setParcelSelected(true)
                    setParcelPopupOpen(true)
                }
            } else if (feature.layer.id == 'zoningRichmondCountyGa') {
                // Handle click on a parcel that is already selected.
                if (parcelSelected &&
                    feature.properties.OBJECTID == selectedParcelData.parcelId
                ) {
                    setParcelSelected(false)
                } else {
                    setSelectedParcelData(
                        Object.assign({
                            'latitude': evt.lngLat.lat,
                            'longitude': evt.lngLat.lng,
                            'parcelId': feature.properties.OBJECTID,
                            'attrDict': layerPopups[feature.layer.id].attrDict,
                        }, feature)
                    )
                    setParcelSelected(true)
                    setParcelPopupOpen(true)
                }
            } else if (feature.layer.id == 'landUseRiversideCountyCa') {
                // Handle click on a parcel that is already selected.
                if (parcelSelected &&
                    feature.properties.PIN == selectedParcelData.parcelId
                ) {
                    setParcelSelected(false)
                } else {
                    setParcelSelected(true)
                    setParcelPopupOpen(true)
                    setSelectedParcelData(
                        Object.assign({
                            'latitude': evt.lngLat.lat,
                            'longitude': evt.lngLat.lng,
                            'attrDict': layerPopups[feature.layer.id].attrDict,
                            'parcelId': feature.properties.PIN
                        }, feature)
                    )
                }
            } else if (feature.layer.id.startsWith('parcels')) {
                // Handle click on a parcel that is already selected.
                const uidField = layer.metadata.uidField
                if (parcelSelected && uidField == selectedParcelData.parcelId
                ) {
                    setParcelSelected(false)
                } else {
                    setSelectedParcelData(
                        Object.assign({
                            'latitude': evt.lngLat.lat,
                            'longitude': evt.lngLat.lng,
                            'parcelId': feature.properties[uidField],
                            'attrDict': layerPopups[feature.layer.id].attrDict,
                        }, feature)
                    )
                    setParcelSelected(true)
                    setParcelPopupOpen(true)
                }
            // } else if (feature.layer.type == 'fill') {
            //     console.log('fill layer feature clicked')
            //     console.log('feature is')
            //     console.log(feature)
            //     setFillLayerPopupData(
            //         Object.assign({
            //             'latitude': evt.lngLat.lat,
            //             'longitude': evt.lngLat.lng,
            //             'title': layerPopups[feature.layer.id].title,
            //             'attrDict': layerPopups[feature.layer.id].attrDict,
            //         }, feature)
            //     )
            } else if (feature.layer.type == 'circle') {
                setCircleLayerPopupData(
                    Object.assign({
                        'latitude': feature.geometry.coordinates[1],
                        'longitude': feature.geometry.coordinates[0],
                        'title': layerPopups[feature.layer.id].title,
                        'attrDict': layerPopups[feature.layer.id].attrDict,
                    }, feature)
                )
            } else if (feature.layer.type == 'symbol') {
                setCircleLayerPopupData(
                    Object.assign({
                        'latitude': feature.geometry.coordinates[1],
                        'longitude': feature.geometry.coordinates[0],
                        'title': layerPopups[feature.layer.id].title,
                        'attrDict': layerPopups[feature.layer.id].attrDict,
                    }, feature)
                )
            } else if (feature.layer.type == 'line') {
                setLineLayerPopupData(
                    Object.assign({
                        'latitude': evt.lngLat.lat,
                        'longitude': evt.lngLat.lng,
                        'title': layerPopups[feature.layer.id].title,
                        'attrDict': layerPopups[feature.layer.id].attrDict,
                    }, feature)
                )
            }
        }
    }

    // Function to find the nearest entry in the JSON data to a given location using
    // Turf.js


    const handleMapClick = async (evt) => {
        // Precedence: circle/line > fill > raster > empty
        if (evt.features && evt.features.length > 0) {
            // Find topmost circle or line feature in clickableLayerIds
            const circleOrLine = evt.features.find(f =>
                (f.layer.type === 'circle' || f.layer.type === 'line' || f.layer.type === 'symbol') &&
                clickableLayerIds.includes(f.layer.id)
            );
            if (circleOrLine) {
                handleFeatureClick(evt, circleOrLine);
                return;
            }
        }
        // Handle click on map when siting mode is on and a new site is allowed:
        if (sitingMode && allowNewSite) {
            setSitingMarkerLng(evt.lngLat.lng)
            setSitingMarkerLat(evt.lngLat.lat)
            setAllowNewSite(false)
            setShowSitingMarkerPopup(true)
            // setCursor('grab')
            // TODO: consolidate separate state variables for site properties
            // into the siteProps state variable (dictionary) to hold them all.
            // Then remove individual site property state variables.
            for (const f of evt.features) {
                if (f.layer.id == 'climateZones') {
                    setSiteClimateZone(f.properties.IECC_Climate_Zone)
                    setSiteClimateType(f.properties.BA_Climate_Zone)
                    setSiteClimateMoisture(f.properties.IECC_Moisture_Regime)
                } else if (f.layer.id == 'temperature') {
                    setSiteTemp(tempData[f.properties.Value]);
                } else if (f.layer.id == 'heatDegDays') {
                    setSiteHeatDegDays(heatDegDaysData[f.properties.GEOID])
                } else if (f.layer.id == 'coolDegDays') {
                    setSiteCoolDegDays(coolDegDaysData[f.properties.GEOID])
                } else if (f.layer.id == 'ceaWorkers') {
                    setSiteCeaWorkers(numWithCommas(f.properties.TOT_EMP))
                    setSiteMetroNonmetroArea(f.properties.AREA_TITLE)
                } else if (f.layer.id == 'warehouseWorkers') {
                    setSiteWarehouseWorkers(numWithCommas(f.properties.TOT_EMP))
                    setSiteMetroNonmetroArea(f.properties.AREA_TITLE)
                } else if (f.layer.id == 'precip') {
                    setSitePrecip(precipData[f.properties.GEOID].toFixed(1))
                } else if (f.layer.id.startsWith('parcels')) {
                    setSelectedParcelData(f)
                    setParcelSelected(true)
                } else if (f.layer.id.startsWith('zoning')) {
                    setSelectedZoningData(f)
                } else if (f.layer.id == 'zipcodes') {
                    const elecPrice = parseFloat(elecPriceData[f.properties.GEOID20]).toFixed(3);
                    setSiteElecPrice(parseFloat(elecPrice))
                } else if (f.layer.id == 'counties') {
                    // TODO: refactor these lookups
                    var edPopLessThanHs;
                    if (f.properties.GEOID in edPopLessThanHsData) {
                        edPopLessThanHs = edPopLessThanHsData[f.properties.GEOID]
                    } else {
                        edPopLessThanHs = "Data Unavailable"
                    }
                    var edPopHsOrHigher;
                    if (f.properties.GEOID in edPopHsOrHigherData) {
                        edPopHsOrHigher =
                            edPopHsOrHigherData[f.properties.GEOID]
                    } else {
                        edPopHsOrHigher = "Data Unavailable"
                    }
                    var edPopBachelorsOrHigher;
                    if (f.properties.GEOID in edPopBachelorsOrHigherData) {
                        edPopBachelorsOrHigher =
                            edPopBachelorsOrHigherData[f.properties.GEOID]
                    } else {
                        edPopBachelorsOrHigher = "Data Unavailable"
                    }
                    const unemploy = unemployData[f.properties.GEOID].toFixed(1)
                    const popDensity = numWithCommas(
                        popDensityData[f.properties.GEOID], 1
                    )
                    const income = numWithCommasUSD(
                        Math.round(incomeData[f.properties.GEOID])
                    )
                    setSiteProps(
                        {
                            'popDensity': popDensity,
                            'income': income,
                            'unemploy': unemploy,
                            'edPopLessThanHs': edPopLessThanHs,
                            'edPopHsOrHigher': edPopHsOrHigher,
                            'edPopBachelorsOrHigher': edPopBachelorsOrHigher,
                        }
                    )
                }
            }
        }
        // Handle raster soil slope click if no features and soilSlope is visible
        else if ((!evt.features || evt.features.length === 0) && layerVisible('soilSlope')) {
            // Get map instance
            const map = mapRef.current;
            if (!map) return;
            // Clamp zoom
            const z = Math.min(Math.floor(map.getZoom()), 12);
            // Convert lng/lat to tile coordinates
            const lng = evt.lngLat.lng;
            const lat = evt.lngLat.lat;
            const n = Math.pow(2, z);
            const tileX = Math.floor((lng + 180) / 360 * n);
            const tileY = Math.floor((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * n);
            // Calculate pixel in tile
            const tileSize = 256;
            const x = ((lng + 180) / 360 * n - tileX) * tileSize;
            const y = ((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * n - tileY) * tileSize;
            // Build tile URL (Mapbox raster v4)
            const url = `https://api.mapbox.com/v4/ceascreeningtooldev.soil_slope/${z}/${tileX}/${tileY}.png?access_token=${mapboxAccessToken}`;
            try {
                const img = new window.Image();
                img.crossOrigin = 'Anonymous';
                img.src = url;
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0);
                    const pixel = ctx.getImageData(Math.floor(x), Math.floor(y), 1, 1).data;
                    // Interpret pixel value (assuming grayscale, use red channel)
                    const value = pixel[0];
                    setSoilSlopePopup({
                        longitude: lng,
                        latitude: lat,
                        value,
                    });
                };
                img.onerror = () => {
                    setSoilSlopePopup(null);
                };
            } catch (e) {
                setSoilSlopePopup(null);
            }
        }
        // Handle raster land cover click if no features and landCover is visible
        else if ((!evt.features || evt.features.length === 0) && layerVisible('landCover')) {
            // Get map instance
            const map = mapRef.current;
            if (!map) return;
            // Clamp zoom
            const z = Math.min(Math.floor(map.getZoom()), 12);
            // Convert lng/lat to tile coordinates
            const lng = evt.lngLat.lng;
            const lat = evt.lngLat.lat;
            const n = Math.pow(2, z);
            const tileX = Math.floor((lng + 180) / 360 * n);
            const tileY = Math.floor((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * n);
            // Calculate pixel in tile
            const tileSize = 256;
            const x = ((lng + 180) / 360 * n - tileX) * tileSize;
            const y = ((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * n - tileY) * tileSize;
            // Build tile URL (Mapbox raster v4)
            const url = `https://api.mapbox.com/v4/ceascreeningtooldev.land_cover_hi/${z}/${tileX}/${tileY}.png?access_token=${mapboxAccessToken}`;
            try {
                const img = new window.Image();
                img.crossOrigin = 'Anonymous';
                img.src = url;
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0);
                    const pixel = ctx.getImageData(Math.floor(x), Math.floor(y), 1, 1).data;
                    // Interpret pixel value (assuming grayscale, use red channel)
                    const value = pixel[0];
                    setLandCoverPopup({
                        longitude: lng,
                        latitude: lat,
                        value,
                    });
                };
                img.onerror = () => {
                    setLandCoverPopup(null);
                };
            } catch (e) {
                setLandCoverPopup(null);
            }
        }
        // Handle raster land cover click if no features and landCover2 is visible
        else if ((!evt.features || evt.features.length === 0) && layerVisible('landCover2')) {
            // Get map instance
            const map = mapRef.current;
            if (!map) return;
            // Clamp zoom
            const z = Math.min(Math.floor(map.getZoom()), 14);
            // Convert lng/lat to tile coordinates
            const lng = evt.lngLat.lng;
            const lat = evt.lngLat.lat;
            const n = Math.pow(2, z);
            const tileX = Math.floor((lng + 180) / 360 * n);
            const tileY = Math.floor((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * n);
            // Calculate pixel in tile
            const tileSize = 256;
            const x = ((lng + 180) / 360 * n - tileX) * tileSize;
            const y = ((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * n - tileY) * tileSize;
            // Build tile URL (Mapbox raster v4)
            const url = `https://api.mapbox.com/v4/ceascreeningtooldev.clipped_land_cover/${z}/${tileX}/${tileY}.png?access_token=${mapboxAccessToken}`;
            try {
                const img = new window.Image();
                img.crossOrigin = 'Anonymous';
                img.src = url;
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0);
                    const pixel = ctx.getImageData(Math.floor(x), Math.floor(y), 1, 1).data;
                    // Interpret pixel value (assuming grayscale, use red channel)
                    const value = pixel[0];
                    setLandCoverPopup({
                        longitude: lng,
                        latitude: lat,
                        value,
                    });
                };
                img.onerror = () => {
                    setLandCoverPopup(null);
                };
            } catch (e) {
                setLandCoverPopup(null);
            }
        }        
        // Handle raster cropland click if no features and cropland is visible
        else if ((!evt.features || evt.features.length === 0) && layerVisible('crops')) {
            // Get map instance
            const map = mapRef.current;
            if (!map) return;
            // Clamp zoom
            const z = Math.min(Math.floor(map.getZoom()), 12);
            // Convert lng/lat to tile coordinates
            const lng = evt.lngLat.lng;
            const lat = evt.lngLat.lat;
            const n = Math.pow(2, z);
            const tileX = Math.floor((lng + 180) / 360 * n);
            const tileY = Math.floor((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * n);
            // Calculate pixel in tile
            const tileSize = 256;
            const x = ((lng + 180) / 360 * n - tileX) * tileSize;
            const y = ((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * n - tileY) * tileSize;
            // Build tile URL (Mapbox raster v4)
            const url = `https://api.mapbox.com/v4/ceascreeningtooldev.clipped_cropland/${z}/${tileX}/${tileY}.png?access_token=${mapboxAccessToken}`;
            try {
                const img = new window.Image();
                img.crossOrigin = 'Anonymous';
                img.src = url;
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0);
                    const pixel = ctx.getImageData(Math.floor(x), Math.floor(y), 1, 1).data;
                    // Interpret pixel value (assuming grayscale, use red channel)
                    const value = pixel[0];
                    setCropsPopup({
                        longitude: lng,
                        latitude: lat,
                        value,
                    });
                };
                img.onerror = () => {
                    setCropsPopup(null);
                };
            } catch (e) {
                setCropsPopup(null);
            }
        } else if (evt.features.length > 0) {
            // ... existing code ...
        }
        // If fill features are clicked (location profile popup)
        if (evt.features && evt.features.length > 0) {
            // Only handle fill layers for location profile
            const fillFeatures = evt.features.filter(f => f.layer.type === 'fill');
            if (fillFeatures.length > 0) {
                // Build attrDicts and propertyDicts for fill features
                var attrDicts = [];
                var propertyDicts = [];
                for (let i = 0; i < evt.features.length; i++) {
                    const feature = evt.features[i];
                    const layer = feature.layer;
                    const attrDict = layerPopups[layer.id]?.attrDict || {};
                    const properties = Object.keys(feature.properties)
                        .filter((key) => Object.keys(attrDict).includes(key))
                        .reduce((obj, key) => {
                            let value = feature.properties[key];

                            // Add commas only to numeric values greater than 1
                            if (typeof value === 'number' && value > 999) {
                                value = numWithCommas(value);
                            }

                            // Limit decimal places for small numbers
                            if (typeof value === 'number' && value < 1) {
                                value = value.toFixed(2);
                            }

                            if (layer.id === 'warehouseWorkers' && value > 999) {
                                value = numWithCommas(value);
                            }

                            if (layer.id === 'ceaWorkers' && value > 999) {
                                value = numWithCommas(value);
                            }

                            if (layer.id === 'ceaWages' && value > 999) {
                                value = numWithCommas(value);
                            }

                            obj[key] = value;
                            return obj;
                        }, {});

                    // Add temperature, precipitation, heating degree days, and cooling degree days
                    if (layer.id === 'temperature') {
                        properties['Temperature (5-year mean) (°F)'] = tempData[feature.properties.GEOID] || 'Unavailable';
                    }
                    if (layer.id === 'precip') {
                        properties['Annual Precipitation (5-year mean) (inches)'] = precipData[feature.properties.GEOID]?.toFixed(1) || 'Unavailable';
                    }
                    if (layer.id === 'heatDegDays') {
                        properties['Annual Heating Degree Days (5-year mean) (°F)'] = numWithCommas(heatDegDaysData[feature.properties.GEOID]) || 'Unavailable';
                    }
                    if (layer.id === 'coolDegDays') {
                        properties['Annual Cooling Degree Days (5-year mean) (°F)'] = numWithCommas(coolDegDaysData[feature.properties.GEOID]) || 'Unavailable';
                    }
                    if (layer.id === 'airQual') {
                        properties['Pollutant'] = airQualData[feature.properties.GEOID]
                    }
                    if (layer.id === 'popDensity') {
                        properties['Population Density (people/km²)'] = numWithCommas(popDensityData[feature.properties.GEOID]) || 'Unavailable';
                    }
                    if (layer.id === 'popDensity') {
                        properties['Population Density (people/km²)'] = numWithCommas(popDensityData[feature.properties.GEOID]) || 'Unavailable';
                    }

                    attrDicts.push(attrDict);
                    propertyDicts.push(properties);
                }

                // Combine data from other layers into a single pop-up
                const properties = Object.assign({}, ...propertyDicts);
                const combinedAttrDict = Object.assign({}, ...attrDicts);

                // Show popup immediately (with soil slope and land cover loading)
                setFillLayerStackPopupData({
                    latitude: evt.lngLat.lat,
                    longitude: evt.lngLat.lng,
                    title: 'Location Profile',
                    attrDict: {
                        ...combinedAttrDict,
                        'Soil Slope (%)': 'Soil Slope (%)',
                        'Land Cover Class': 'Land Cover Class',
                        'Crop Class': 'Crop Class',
                        'Temperature (5-year mean) (°F)': 'Temperature (5-year mean) (°F)',
                        'Annual Precipitation (5-year mean) (inches)': 'Annual Precipitation (5-year mean) (inches)',
                        'Annual Heating Degree Days (5-year mean) (°F)': 'Annual Heating Degree Days (5-year mean) (°F)',
                        'Annual Cooling Degree Days (5-year mean) (°F)': 'Annual Cooling Degree Days (5-year mean) (°F)',
                        'Population Density (people/km²)':'Population Density (people/km²)'
                    },
                    properties: {
                        ...properties,
                        'Soil Slope (%)': soilSlopeVisible ? 'Loading...' : 'Unavailable',
                        'Land Cover Class': landCoverVisible ? 'Loading...' : 'Unavailable',
                        'Crop Class': cropsVisible ? 'Loading...' : 'Unavailable',
                    },
                });

                // Fetch and update soil slope value
                const map = mapRef.current;
                const soilSlopeValue = await getSoilSlopeValueAtLatLng(evt.lngLat.lng, evt.lngLat.lat, map);
                setFillLayerStackPopupData((prev) => {
                    if (!prev) return prev;
                    return {
                        ...prev,
                        properties: {
                            ...prev.properties,
                            'Soil Slope (%)': soilSlopeValue !== null ? soilSlopeValue : 'Unavailable',
                        },
                    };
                });

                // Fetch and update land cover value
                let landCoverValue = null; // Declare the variable outside the blocks
        
                if (evt.lngLat.lng < -150) {
                    landCoverValue = await getLandCoverValueAtLatLng(evt.lngLat.lng, evt.lngLat.lat, map, 'landCover');
                } else {
                    landCoverValue = await getLandCoverValueAtLatLng(evt.lngLat.lng, evt.lngLat.lat, map, 'landCover2');
                }
            
                setFillLayerStackPopupData((prev) => {
                    if (!prev) return prev;
                    return {
                        ...prev,
                        properties: {
                            ...prev.properties,
                            'Land Cover Class': landCoverValue !== null ? landCoverValue : 'Unavailable',
                        },
                    };
                });                

                // Fetch and update cropland value
                const cropsValue = await getCropsValueAtLatLng(evt.lngLat.lng, evt.lngLat.lat, map);
                setFillLayerStackPopupData((prev) => {
                    if (!prev) return prev;
                    return {
                        ...prev,
                        properties: {
                            ...prev.properties,
                            'Crop Class': cropsValue !== null ? cropsValue : 'Unavailable',
                        },
                    };
                });
            }    
        }
    }

    const parcelsVisible = () => {
        var vis = false
        layers.forEach((layer) => {
            if (layer.id.startsWith('parcels')) {
                const layerType = layer['type'];
                var opacityProp = `${layerType}-opacity`
                if (layerType === 'symbol') {
                    opacityProp = 'icon-opacity'
                }
                const visible = layer.paint[opacityProp] != 0
                if (visible) {
                    vis = true
                }
            }
        })
        return vis
    }

    // Add this near the top of MapPage (after other hooks and before handlers)
    const getSoilSlopeValueAtLatLng = async (lng, lat, map) => {
        const RASTER_MAX_ZOOM = 12;
        const z = Math.min(Math.floor(map.getZoom()), RASTER_MAX_ZOOM);
        const n = Math.pow(2, z);
        const tileX = Math.floor((lng + 180) / 360 * n);
        const tileY = Math.floor(
            (1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * n
        );
        const tileSize = 256;
        const x = ((lng + 180) / 360 * n - tileX) * tileSize;
        const y = ((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * n - tileY) * tileSize;

        // Get access token from config or env
        const accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN || process.env.MAPBOX_ACCESS_TOKEN || '<YOUR_MAPBOX_ACCESS_TOKEN>';
        const url = `https://api.mapbox.com/v4/ceascreeningtooldev.soil_slope/${z}/${tileX}/${tileY}@2x.pngraw?access_token=${accessToken}`;
        try {
            const response = await fetch(url);
            if (!response.ok) return null;
            const blob = await response.blob();
            const bitmap = await createImageBitmap(blob);
            const canvas = document.createElement('canvas');
            canvas.width = bitmap.width;
            canvas.height = bitmap.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(bitmap, 0, 0);
            const pixel = ctx.getImageData(Math.floor(x), Math.floor(y), 1, 1).data;
            // Example: decode grayscale value (if encoded as grayscale)
            // If encoded differently, adjust this logic
            const value = pixel[0];
            return value;
        } catch (e) {
            return null;
        }
    };

    const getLandCoverValueAtLatLng = async (lng, lat, map, layerId) => {
        console.log('Fetching Land Cover value for:', { lng, lat });
        const RASTER_MAX_ZOOM = 12;
        const z = Math.min(Math.floor(map.getZoom()), RASTER_MAX_ZOOM);
        const n = Math.pow(2, z);
        const tileX = Math.floor((lng + 180) / 360 * n);
        const tileY = Math.floor(
            (1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * n
        );
        const tileSize = 256;
        const x = ((lng + 180) / 360 * n - tileX) * tileSize;
        const y = ((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * n - tileY) * tileSize;

        // Get access token from config or env
        const accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN || process.env.MAPBOX_ACCESS_TOKEN || '<YOUR_MAPBOX_ACCESS_TOKEN>';
        let url; // Declare the variable outside the blocks
        if (layerId === 'landCover') {
            url = `https://api.mapbox.com/v4/ceascreeningtooldev.land_cover_hi/${z}/${tileX}/${tileY}@2x.pngraw?access_token=${accessToken}`;
        } else if (layerId === 'landCover2') {
            url = `https://api.mapbox.com/v4/ceascreeningtooldev.clipped_land_cover/${z}/${tileX}/${tileY}@2x.pngraw?access_token=${accessToken}`;
        }
        try {
            const response = await fetch(url);
            if (!response.ok) return null;
            const blob = await response.blob();
            const bitmap = await createImageBitmap(blob);
            const canvas = document.createElement('canvas');
            canvas.width = bitmap.width;
            canvas.height = bitmap.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(bitmap, 0, 0);
            const pixel = ctx.getImageData(Math.floor(x), Math.floor(y), 1, 1).data;
            // Example: decode grayscale value (if encoded as grayscale)
            // If encoded differently, adjust this logic
            const value = pixel[0];
            return value;
        } catch (e) {
            console.error('Error fetching Land Cover value:', e);
            return null;
        }
    };

    const getCropsValueAtLatLng = async (lng, lat, map) => {
        const RASTER_MAX_ZOOM = 12;
        const z = Math.min(Math.floor(map.getZoom()), RASTER_MAX_ZOOM);
        const n = Math.pow(2, z);
        const tileX = Math.floor((lng + 180) / 360 * n);
        const tileY = Math.floor(
            (1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * n
        );
        const tileSize = 256;
        const x = ((lng + 180) / 360 * n - tileX) * tileSize;
        const y = ((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * n - tileY) * tileSize;

        // Get access token from config or env
        const accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN || process.env.MAPBOX_ACCESS_TOKEN || '<YOUR_MAPBOX_ACCESS_TOKEN>';
        const url = `https://api.mapbox.com/v4/ceascreeningtooldev.clipped_cropland/${z}/${tileX}/${tileY}@2x.pngraw?access_token=${accessToken}`;
        try {
            const response = await fetch(url);
            if (!response.ok) return null;
            const blob = await response.blob();
            const bitmap = await createImageBitmap(blob);
            const canvas = document.createElement('canvas');
            canvas.width = bitmap.width;
            canvas.height = bitmap.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(bitmap, 0, 0);
            const pixel = ctx.getImageData(Math.floor(x), Math.floor(y), 1, 1).data;
            // Example: decode grayscale value (if encoded as grayscale)
            // If encoded differently, adjust this logic
            const value = pixel[0];
            return value;
        } catch (e) {
            return null;
        }
    };

    return (
      <Map
        mapboxAccessToken={mapboxAccessToken}
        ref={mapRefCallback}
        initialViewState={{
          latitude: 40,
          longitude: -100,
          zoom: 3.9,
        }}
        // Make all layers in the `layers` array interactive by default.
        interactiveLayerIds={layers.map((layer) => layer.id)}
        mapStyle={mapStyle}
        onClick={(evt) => handleMapClick(evt)}
        onDragStart={(evt) => mapOnDragStart(evt)}
        onDragEnd={(evt) => mapOnDragEnd(evt)}
        cursor={cursor}
        // onMouseEnter={onMouseEnter}
        // onMouseLeave={onMouseLeave}
        onMouseMove={onMouseMove}
        onLoad={(evt) => handleMapOnLoad(evt)}
      >
        {/* Render raster layers first (below vector layers) */}
        {soilSlopeVisible && (
            <Source
                id="soilSlope"
                type="raster"
                url="mapbox://ceascreeningtooldev.soil_slope"
                tileSize={256}
            >
                <Layer
                    id="soilSlope"
                    type="raster"
                    paint={{ 'raster-opacity': soilSlopeOpacity }}
                />
            </Source>
        )}
        {landCoverVisible && (
            <Source
                id="landCover"
                type="raster"
                url="mapbox://ceascreeningtooldev.land_cover_hi"
                tileSize={256}
            >
                <Layer
                    id="landCover"
                    type="raster"
                    paint={{ 'raster-opacity': landCoverOpacity }}
                />
            </Source>
        )}
        {landCoverVisible && (
            <Source
                id="landCover2"
                type="raster"
                url="mapbox://ceascreeningtooldev.clipped_land_cover"
                tileSize={256}
            >
                <Layer
                    id="landCover2"
                    type="raster"
                    paint={{ 'raster-opacity': landCoverOpacity }}
                />
            </Source>
        )}
        {cropsVisible && (
            <Source
                id="crops"
                type="raster"
                url="mapbox://ceascreeningtooldev.clipped_cropland"
                tileSize={256}
            >
                <Layer
                    id="crops"
                    type="raster"
                    paint={{ 'raster-opacity': cropsOpacity }}
                />
            </Source>
        )}

        {/* Render vector layers (circle, line, fill) above raster */}
        {layers.map((layer) => (
            <Source
                type="vector"
                url={layer.source as string}
                key={layer.id + "-source-wrapper"}
            >
                <Layer
                    key={layer.id}
                    {...(({ source, ...rest }) => rest)(layer)}
                />
            </Source>
        ))}

        {parcelSelected && parcelsVisible() && (
          <>
            <Source
              id="parcelSelectedRichmondCountyGa"
              type="vector"
              url={zoningRichmondCountyGaLayer.source as string}
            >
              <Layer
                id="parcelSelectedRichmondCountyGa"
                type="fill"
                {...selectedParcelRichmondCountyGaLayer}
              />
              <Layer
                id="parcelSelectedBorderRichmondCountyGa"
                type="line" // Corrected duplicate type
                {...selectedParcelBorderRichmondCountyGaLayer}
              />
            </Source>
            <Source
              id="selected-kauai-county-hi-parcel"
              type="vector"
              url={landUseKauaiCountyHiLayer.source as string}
            >
              <Layer
                id="selected-parcel-kauai" // Unique key/id
                type="fill"
                {...selectedParcelKauaiCountyHiLayer}
              />
              <Layer
                id="selected-parcel-border-kauai" // Unique key/id
                type="line"
                {...selectedParcelBorderKauaiCountyHiLayer}
              />
            </Source>
            <Source
              id="selectedLorainCountyOhParcel"
              type="vector"
              url={landValueLorainCountyOhLayer.source as string}
            >
              <Layer
                id="selectedParcelLorain" // Unique key/id
                type="fill"
                {...selectedParcelLorainCountyOhLayer}
              />
              <Layer
                id="selectedParcelBorderLorain" // Unique key/id
                type="line"
                {...selectedParcelBorderLorainCountyOhLayer}
              />
            </Source>
            <Source
              id="selectedMonroeCountyMiParcel"
              type="vector"
              url={landValueMonroeCountyMiLayer.source as string}
            >
              <Layer
                id="selectedParcelMonroe" // Unique key/id
                type="fill"
                {...selectedParcelMonroeCountyMiLayer}
              />
              <Layer
                id="selectedParcelBorderMonroe" // Unique key/id
                type="line"
                {...selectedParcelBorderMonroeCountyMiLayer}
              />
            </Source>
            {/* Removed duplicate selectedMonroeCountyMiParcel Source and Layers */}
            <Source
              id="selectedWayneCountyOhParcel"
              type="vector"
              url={landUseWayneCountyOhLayer.source as string}
            >
              <Layer
                id="selectedParcelWayneOh" // Unique key/id
                type="fill"
                {...selectedParcelWayneCountyOhLayer}
              />
              <Layer
                id="selectedParcelBorderWayneOh" // Unique key/id
                type="line"
                {...selectedParcelBorderWayneCountyOhLayer}
              />
            </Source>
            <Source
              id="selectedErieCountyOhParcel"
              type="vector"
              url={landValueErieCountyOhLayer.source as string}
            >
              <Layer
                id="selectedParcelErie" // Unique key/id
                type="fill"
                {...selectedParcelErieCountyOhLayer}
              />
              <Layer
                id="selectedParcelBorderErie" // Unique key/id
                type="line"
                {...selectedParcelBorderErieCountyOhLayer}
              />
            </Source>
            <Source
              id="selectedWayneCountyMiParcel"
              type="vector"
              url={landUseWayneCountyMiLayer.source as string}
            >
              <Layer
                id="selectedParcelWayneMi" // Unique key/id
                type="fill"
                {...selectedParcelWayneCountyMiLayer}
              />
              <Layer
                id="selectedParcelBorderWayneMi" // Unique key/id
                type="line"
                {...selectedParcelBorderWayneCountyMiLayer}
              />
            </Source>
            <Source
              id="selected-ottawa-county-oh-parcel"
              type="vector"
              url={landUseOttawaCountyOhLayer.source as string}
            >
              <Layer
                id="selected-parcel-ottawa" // Unique key/id
                type="fill"
                {...selectedParcelOttawaCountyOhLayer}
              />
              <Layer
                id="selected-parcel-border-ottawa" // Unique key/id
                type="line"
                {...selectedParcelBorderOttawaCountyOhLayer}
              />
            </Source>
            <Source
              id="selected-lucas-county-oh-parcel"
              type="vector"
              url={landValueLucasCountyOhLayer.source as string}
            >
              <Layer
                id="selected-parcel-lucas" // Unique key/id
                type="fill"
                {...selectedParcelLucasCountyOhLayer}
              />
              <Layer
                id="selected-parcel-border-lucas" // Unique key/id
                type="line"
                {...selectedParcelBorderLucasCountyOhLayer}
              />
            </Source>
            <Source
              id="selected-york-county-pa-parcel"
              type="vector"
              url={landValueYorkCountyPaLayer.source as string}
            >
              <Layer
                id="selected-parcel-york" // Unique key/id
                type="fill"
                {...selectedParcelYorkCountyPaLayer}
              />
              <Layer
                id="selected-parcel-border-york" // Unique key/id
                type="line"
                {...selectedParcelBorderYorkCountyPaLayer}
              />
            </Source>
            <Source
              id="selected-riverside-county-ca-parcel"
              type="vector"
              url={landValueRiversideCountyCaLayer.source as string}
            >
              <Layer
                id="selected-parcel-riverside" // Unique key/id
                type="fill"
                {...selectedParcelRiversideCountyCaLayer}
              />
              <Layer
                id="selected-parcel-border-riverside" // Unique key/id
                type="line"
                {...selectedParcelBorderRiversideCountyCaLayer}
              />
            </Source>
          </>
        )}
        {/*<Layer {...cejstLayer}/>*/}
        {/*<GeolocateControl position="top-right"/>*/}
        <NavigationControl position="bottom-right" showCompass={false} />

        {numFillLayersVisible() == 1 &&
          (layerVisible("temperature") ||
            layerVisible("heatDegDays") ||
            layerVisible("coolDegDays") ||
            layerVisible("climateZones")) && <ColorKeyControl />}
        {/*<Button variant="warning"*/}
        {/*        className={'pb-0'}*/}
        {/*        style={{*/}
        {/*            // backgroundColor: 'white',*/}
        {/*            width: '219px',*/}
        {/*            fontSize: '14px',*/}
        {/*            // width: '100%',*/}
        {/*            position: 'absolute',*/}
        {/*            // bottom: '22px',*/}
        {/*            top: '-28px',*/}
        {/*            // right: '288px',*/}
        {/*            zIndex: 1000,*/}
        {/*            left: '7px',*/}
        {/*            border: '1.5px solid #FFFFFF',*/}
        {/*            // opacity: '90%'*/}
        {/*        }}*/}
        {/*        onClick={(evt) => handleFeedbackBtnClick(evt)}*/}
        {/*    // disabled={props.allowNewSite}*/}
        {/*>*/}
        {/*    <p className={'mb-2'}*/}
        {/*       style={{color: 'black'}}><strong>Give Feedback</strong>*/}
        {/*    </p>*/}
        {/*</Button>*/}
        {/*<Modal*/}
        {/*    style={{*/}
        {/*        marginTop: '300px'*/}
        {/*    }}*/}
        {/*    show={show} onHide={handleClose}>*/}
        {/*    <Modal.Header closeButton>*/}
        {/*        <Modal.Title>Help us improve this tool!</Modal.Title>*/}
        {/*    </Modal.Header>*/}
        {/*    <Modal.Body className={'text-center'}>*/}
        {/*        <p>*/}
        {/*            To provide feedback on how this tool could be*/}
        {/*            improved,*/}
        {/*            or*/}
        {/*            to report a bug, issue or feature request, please*/}
        {/*            email*/}
        {/*            us*/}
        {/*            at:*/}
        {/*        </p>*/}
        {/*        <p className={'text-center'}>*/}
        {/*            <a href="mailto: name@email.com">*/}
        {/*                <strong>ceascreeningtooldev@gmail.com </strong></a>*/}
        {/*        </p>*/}
        {/*        <p>*/}
        {/*            We value your input and will respond as*/}
        {/*            soon as possible!*/}
        {/*        </p>*/}
        {/*    </Modal.Body>*/}
        {/*    <Modal.Footer>*/}
        {/*        <Button variant="secondary" onClick={handleClose}>*/}
        {/*            Close*/}
        {/*        </Button>*/}
        {/*        /!*<Button variant="primary" onClick={handleClose}>*!/*/}
        {/*        /!*    Save Changes*!/*/}
        {/*        /!*</Button>*!/*/}
        {/*    </Modal.Footer>*/}
        {/*</Modal>*/}
        {/*<FullscreenControl position="top-left"/>*/}
        {/*<ScaleControl/>*/}
        {/*<ControlPanel/>*/}
        <LayerControl
          layers={layers}
          layerTree={layerTree}
          onChange={setLayers}
          activeCollapses={activeLayerCollapses}
          activeCollapsesSetter={setActiveLayerCollapses}
          soilSlopeVisible={soilSlopeVisible}
          setSoilSlopeVisible={setSoilSlopeVisible}
          soilSlopeOpacity={soilSlopeOpacity}
          setSoilSlopeOpacity={setSoilSlopeOpacity}
          landCoverVisible={landCoverVisible}
          setLandCoverVisible={setLandCoverVisible}
          landCoverOpacity={landCoverOpacity}
          setLandCoverOpacity={setLandCoverOpacity}
          cropsVisible={cropsVisible}
          setCropsVisible={setCropsVisible}
          cropsOpacity={cropsOpacity}
          setCropsOpacity={setCropsOpacity}
        />
        <GeocoderControl
          mapboxAccessToken={mapboxAccessToken}
          position="top-left"
          className={"geocoder-control"}
          style={{ width: "320px" }}
        />
        {/*<BasemapOverlayControl layers={layers} onChange={setLayers}/>*/}
        <SitingModeControl
            style={{
              position: "absolute",
              top: "8px",
              left: "338px",
              zIndex: 990,
              width: "300px",
            }}
          sitingMode={sitingMode}
          sitingModeSetter={setSitingMode}
          allowNewSite={allowNewSite}
          allowNewSiteSetter={setAllowNewSite}
          showSitingMarkerPopupSetter={setShowSitingMarkerPopup}
          cursorSetter={setCursor}
          facilityFilterVisibleSetter={setFacilityFilterVisible}
          baselineResultsVisibleSetter={setBaselineResultsVisible}
          pathwaysResultsVisibleSetter={setPathwaysResultsVisible}
          // baselineResults={baselineResults} // Prop removed from SitingModeControl
          onAccordionToggle={setSitingModeAccordionExpanded} // New prop
        />
        {sitingMode &&
          !allowNewSite &&
          sitingMarkerLat !== null &&
          sitingMarkerLng !== null && (
            <Marker
              latitude={sitingMarkerLat}
              longitude={sitingMarkerLng}
              onClick={(evt) => {
                evt.originalEvent.stopPropagation();
                setShowSitingMarkerPopup(true);
              }}
              // onClick={() => console.log('marker clicked')}
            />
          )}
        {showSitingMarkerPopup &&
          sitingMarkerLat !== null &&
          sitingMarkerLng !== null && (
            <Popup
              longitude={sitingMarkerLng}
              latitude={sitingMarkerLat}
              anchor="bottom"
              style={{ paddingBottom: "35px" }}
              onClose={() => setShowSitingMarkerPopup(false)}
              closeOnClick={false}
              maxWidth={"700px"}
            >
              <strong style={{ fontSize: "1rem" }}>Proposed Site</strong>
              <hr className={"mb-1 mt-1"} />
              <div>
                Latitude:{" "}
                {sitingMarkerLat !== null ? sitingMarkerLat.toFixed(6) : "N/A"}
              </div>
              <div>
                Longitude:{" "}
                {sitingMarkerLng !== null ? sitingMarkerLng.toFixed(6) : "N/A"}
              </div>
              <hr className={"mb-1 mt-1"} />
              <strong>Climate & Environment</strong>
              <div>IECC Climate Zone: {siteClimateZone}</div>
              <div>IECC Climate Moisture Class: {siteClimateMoisture}</div>
              <div>Climate Type: {siteClimateType}</div>
              <div>Temperature (5-year mean) (°F): {siteTemp} </div>
              <div>
                Annual Heating Degree Days (5-year mean) (°F):&nbsp;
                {numWithCommas(siteHeatDegDays)} 
              </div>
              <div>
                Annual Cooling Degree Days (5-year mean) (°F):&nbsp;
                {numWithCommas(siteCoolDegDays)} 
              </div>
              <div>Annual Precipitation (5-year avg.): {sitePrecip} in</div>
              <strong>Land Use & Utilities</strong>
              <div>Electricity Price: {siteElecPrice} $/kWh</div>
              {/* TODO (@Tyler): Include zoning info of site here.*/}
              <strong>Social & Economic Stats</strong>
              <div>Population Density: {siteProps.popDensity} people/km²</div>
              <div>Per Capita Personal Income: {siteProps.income}</div>
              <div>
                Metropolitan/Nonmetropolitan Area:&nbsp;
                {siteMetroNonmetroArea}
              </div>
              <div>
                Estimated Number of CEA Workers in Metro/Nonmetro Area: &nbsp;
                {numWithCommas(parseInt(siteCeaWorkers))}
              </div>
              <div>
                Estimated Number of Warehouse Workers in Metro/Nonmetro Area:
                &nbsp;
                {numWithCommas(parseInt(siteCeaWorkers))}
              </div>
              <div>Unemployment Rate: {siteProps.unemploy}%</div>
              {siteProps.edPopLessThanHs !== "Data Unavailable" && (
                <>
                  <div>
                    Population with Less Than High School Diploma:&nbsp;
                    {numWithCommas(parseInt(siteProps.edPopLessThanHs))}
                  </div>
                  <div>
                    Population with High School Diploma or Higher:&nbsp;
                    {numWithCommas(parseInt(siteProps.edPopHsOrHigher))}
                  </div>
                  <div>
                    Population with Bachelor's Degree or Higher:&nbsp;
                    {numWithCommas(parseInt(siteProps.edPopBachelorsOrHigher))}
                  </div>
                </>
              )}
            </Popup>
          )}
        {/*{landfillPopupData &&*/}
        {/*    <LandfillPopup*/}
        {/*        landfillPopupData={landfillPopupData}*/}
        {/*        landfillPopupDataSetter={setLandfillPopupData}*/}
        {/*    />*/}
        {/*}*/}
        {/*{compostFacilityPopupData &&*/}
        {/*    <GenericCirclePopup*/}
        {/*        popupData={compostFacilityPopupData}*/}
        {/*        popupDataSetter={setCompostFacilityPopupData}*/}
        {/*    />*/}
        {/*}*/}
        {/*{wtrPollCtrlFacilityPaPopupData &&*/}
        {/*    <GenericCirclePopup*/}
        {/*        popupData={wtrPollCtrlFacilityPaPopupData}*/}
        {/*        popupDataSetter={setWtrPollCtrlFacilityPaPopupData}*/}
        {/*    />*/}
        {/*}*/}
        {/*{wastewaterTreatPlantPopupData &&*/}
        {/*    <GenericCirclePopup*/}
        {/*        popupData={wastewaterTreatPlantPopupData}*/}
        {/*        popupDataSetter={setWastewaterTreatPlantPopupData}*/}
        {/*    />*/}
        {/*}*/}
        {circleLayerPopupData && (
          <GenericCircleLayerPopup
            popupData={circleLayerPopupData}
            popupDataSetter={setCircleLayerPopupData}
          />
        )}
        {lineLayerPopupData && (
          <GenericLineLayerPopup
            popupData={lineLayerPopupData}
            popupDataSetter={setLineLayerPopupData}
          />
        )}
        {fillLayerPopupData && (
          <GenericFillLayerPopup
            popupData={fillLayerPopupData}
            popupDataSetter={setFillLayerPopupData}
          />
        )}
        {fillLayerStackPopupData && (
          <FillLayerStackPopup
            popupData={fillLayerStackPopupData}
            popupDataSetter={setFillLayerStackPopupData}
          />
        )}
        {/*{selectedCensusTractData &&*/}
        {/*    <GenericFillLayerPopup*/}
        {/*        popupData={censusTr}*/}
        {/*        popupDataSetter={setFillLayerPopupData}*/}
        {/*    />*/}
        {/*}*/}
        {parcelPopupOpen && parcelSelected && parcelsVisible() && (
          <Popup
            longitude={selectedParcelData.longitude}
            latitude={selectedParcelData.latitude}
            anchor="bottom-left"
            style={{ paddingBottom: "10px" }}
            onClose={() => setParcelPopupOpen(false)}
            closeOnClick={false}
            maxWidth={"700px"}
          >
            <strong style={{ fontSize: "1rem" }}>Parcel</strong>
            <hr className={"mb-1 mt-1"} />

            {selectedParcelData.properties &&
              selectedParcelData.attrDict &&
              Object.entries(selectedParcelData.properties).map(
                ([k, v]) =>
                  Object.keys(selectedParcelData.attrDict).includes(k) && (
                    <div key={k}>
                      <strong>{selectedParcelData.attrDict[k]}: </strong>
                      {
                        selectedParcelData.attrDict[k].includes("Value") ||
                        selectedParcelData.attrDict[k].includes("Appraisal") ||
                        selectedParcelData.attrDict[k].includes("Price")
                          ? numWithCommasUSD(v as number) // Assuming v is number for these cases
                          : String(v) // Ensure v is ReactNode
                      }
                    </div>
                  ),
              )}
          </Popup>
        )}
        {sitingMode && facilityFilterVisible && (
          <FacilityFilterControl
            style={{
              position: "absolute",
              top: sitingModeAccordionExpanded ? "125px" : "65px", // Conditional top
              left: "338px",
              zIndex: 990,
              width: "300px",
            }}
            allowNewSite={allowNewSite}
            searchRad={searchRad}
            searchRadSetter={setSearchRad}
            sitingMarkerLngLat={sitingMarkerLngLat}
            baselineResultsSetter={setBaselineResults}
            facilityParams={facilityParams}
            facilityParamsSetter={setFacilityParams}
            activeCollapses={activeFacilityCollapses}
            activeCollapsesSetter={setActiveFacilityCollapses}
            baselineResultsVisibleSetter={setBaselineResultsVisible}
            pathwayResultsVisibleSetter={setPathwaysResultsVisible}
          />
        )}
        {sitingMode && baselineResultsVisible && (
          <BaselineResultsControl
            baselineResults={baselineResults}
            pathwaysResultsSetter={setPathwaysResults}
            pathwaysResultsVisibleSetter={setPathwaysResultsVisible}
          />
        )}
        {sitingMode && pathwaysResultsVisible && (
          <PathwaysResultsControl
            baselineResults={baselineResults}
            pathwaysResults={pathwaysResults}
            pathwaysResultsVisibleSetter={setPathwaysResultsVisible}
          />
        )}
        {sitingMode &&
          !allowNewSite &&
          sitingMarkerLng !== null &&
          sitingMarkerLat !== null && (
            <>
              <Source
                id="search-rad-circ"
                type="geojson"
                data={searchRadCirc as GeoJSON.Feature<GeoJSON.Polygon>}
              >
                <Layer
                  id="search-rad-circ"
                  type="fill"
                  paint={{
                    "fill-color": "#088",
                    "fill-opacity": searchRadFillOpacity,
                    "fill-outline-color": "yellow",
                  }}
                />
              </Source>
              <Source
                id="search-rad-line"
                type="geojson" // Changed url to data for GeoJSON source
                data={searchRadLine as GeoJSON.Feature<GeoJSON.LineString>}
              >
                <Layer
                  id="search-rad-line"
                  type="line"
                  paint={{
                    "line-color": "yellow",
                    "line-width": 2,
                  }}
                />
              </Source>
            </>
          )}
        {!sitingMode && (
          <WelcomeMessage
            loading={loading}
            spinner={
              <RingLoader
                loading={loading}
                cssOverride={{
                  display: "block",
                  margin: "0 auto",
                }}
                color={"#1cda5f"}
                size={35}
              />
            }
          />
        )}
        {soilSlopePopup && (
          <Popup
            longitude={soilSlopePopup.longitude}
            latitude={soilSlopePopup.latitude}
            anchor="top"
            onClose={() => setSoilSlopePopup(null)}
            closeOnClick={false}
            maxWidth={"auto"}
          >
            <strong>Soil Slope Value</strong>
            <hr className={"mb-1 mt-1"} />
            <div>Value: {soilSlopePopup.value}</div>
          </Popup>
        )}
        {soilSlopeVisible && (
          <Source
            id="soilSlope"
            type="raster"
            url={soilSlopeLayer.source as string}
          >
            <Layer
              id="soilSlope"
              type="raster"
              paint={{ 'raster-opacity': soilSlopeOpacity }}
            />
          </Source>
        )}
        {landCoverPopup && (
          <Popup
            longitude={landCoverPopup.longitude}
            latitude={landCoverPopup.latitude}
            anchor="top"
            onClose={() => setLandCoverPopup(null)}
            closeOnClick={false}
            maxWidth={"auto"}
          >
            <strong>Land Cover Value</strong>
            <hr className={"mb-1 mt-1"} />
            <div>Value: {landCoverPopup.value}</div>
          </Popup>
        )}
        {landCoverVisible && (
          <Source
            id="landCover"
            type="raster"
            url={landCoverLayer.source as string}
          >
            <Layer
              id="landCover"
              type="raster"
              paint={{ 'raster-opacity': landCoverOpacity }}
            />
          </Source>
        )}
        {landCoverVisible && (
          <Source
            id="landCover2"
            type="raster"
            url={landCover2Layer.source as string}
          >
            <Layer
              id="landCover2"
              type="raster"
              paint={{ 'raster-opacity': landCoverOpacity }}
            />
          </Source>
        )}
        {cropsPopup && (
          <Popup
            longitude={cropsPopup.longitude}
            latitude={cropsPopup.latitude}
            anchor="top"
            onClose={() => setCropsPopup(null)}
            closeOnClick={false}
            maxWidth={"auto"}
          >
            <strong>Crop Class</strong>
            <hr className={"mb-1 mt-1"} />
            <div>Value: {cropsPopup.value}</div>
          </Popup>
        )}
        {cropsVisible && (
          <Source
            id="crops"
            type="raster"
            url={cropsLayer.source as string}
          >
            <Layer
              id="crops"
              type="raster"
              paint={{ 'raster-opacity': cropsOpacity }}
            />
          </Source>
        )}
      </Map>
    );
}

export default MapPage;
